(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90078,99965,7762],{

/***/ 71213:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./_lib/buildFormatLongFn/index.js": [
		20289,
		7,
		20289
	],
	"./_lib/buildLocalizeFn/index.js": [
		16245,
		7,
		16245
	],
	"./_lib/buildMatchFn/index.js": [
		43421,
		7,
		43421
	],
	"./_lib/buildMatchPatternFn/index.js": [
		78926,
		7,
		78926
	],
	"./af/_lib/formatDistance/index.js": [
		41146,
		7,
		41146
	],
	"./af/_lib/formatLong/index.js": [
		60358,
		7,
		60358
	],
	"./af/_lib/formatRelative/index.js": [
		31310,
		7,
		31310
	],
	"./af/_lib/localize/index.js": [
		82714,
		7,
		82714
	],
	"./af/_lib/match/index.js": [
		33185,
		7,
		33185
	],
	"./af/index.js": [
		74156,
		7,
		74156
	],
	"./ar-DZ/_lib/formatDistance/index.js": [
		10258,
		7,
		10258
	],
	"./ar-DZ/_lib/formatLong/index.js": [
		38384,
		7,
		38384
	],
	"./ar-DZ/_lib/formatRelative/index.js": [
		12923,
		7,
		12923
	],
	"./ar-DZ/_lib/localize/index.js": [
		50996,
		7,
		50996
	],
	"./ar-DZ/_lib/match/index.js": [
		53463,
		7,
		53463
	],
	"./ar-DZ/index.js": [
		79307,
		7,
		79307
	],
	"./ar-EG/_lib/formatDistance/index.js": [
		70405,
		7,
		70405
	],
	"./ar-EG/_lib/formatLong/index.js": [
		59137,
		7,
		59137
	],
	"./ar-EG/_lib/formatRelative/index.js": [
		19798,
		7,
		19798
	],
	"./ar-EG/_lib/localize/index.js": [
		20303,
		7,
		20303
	],
	"./ar-EG/_lib/match/index.js": [
		2527,
		7,
		2527
	],
	"./ar-EG/index.js": [
		56379,
		7,
		56379
	],
	"./ar-MA/_lib/formatDistance/index.js": [
		56716,
		7,
		56716
	],
	"./ar-MA/_lib/formatLong/index.js": [
		92086,
		7,
		92086
	],
	"./ar-MA/_lib/formatRelative/index.js": [
		79302,
		7,
		79302
	],
	"./ar-MA/_lib/localize/index.js": [
		89105,
		7,
		89105
	],
	"./ar-MA/_lib/match/index.js": [
		18092,
		7,
		18092
	],
	"./ar-MA/index.js": [
		22739,
		7,
		22739
	],
	"./ar-SA/_lib/formatDistance/index.js": [
		56224,
		7,
		56224
	],
	"./ar-SA/_lib/formatLong/index.js": [
		22041,
		7,
		22041
	],
	"./ar-SA/_lib/formatRelative/index.js": [
		90046,
		7,
		90046
	],
	"./ar-SA/_lib/localize/index.js": [
		16274,
		7,
		16274
	],
	"./ar-SA/_lib/match/index.js": [
		7161,
		7,
		7161
	],
	"./ar-SA/index.js": [
		51730,
		7,
		51730
	],
	"./ar-TN/_lib/formatDistance/index.js": [
		98818,
		7,
		98818
	],
	"./ar-TN/_lib/formatLong/index.js": [
		19048,
		7,
		19048
	],
	"./ar-TN/_lib/formatRelative/index.js": [
		30005,
		7,
		30005
	],
	"./ar-TN/_lib/localize/index.js": [
		7649,
		7,
		7649
	],
	"./ar-TN/_lib/match/index.js": [
		34357,
		7,
		34357
	],
	"./ar-TN/index.js": [
		37650,
		7,
		37650
	],
	"./ar/_lib/formatDistance/index.js": [
		29226,
		7,
		29226
	],
	"./ar/_lib/formatLong/index.js": [
		45604,
		7,
		45604
	],
	"./ar/_lib/formatRelative/index.js": [
		77237,
		7,
		77237
	],
	"./ar/_lib/localize/index.js": [
		72890,
		7,
		72890
	],
	"./ar/_lib/match/index.js": [
		53372,
		7,
		53372
	],
	"./ar/index.js": [
		18137,
		7,
		18137
	],
	"./az/_lib/formatDistance/index.js": [
		67580,
		7,
		67580
	],
	"./az/_lib/formatLong/index.js": [
		3381,
		7,
		3381
	],
	"./az/_lib/formatRelative/index.js": [
		5895,
		7,
		5895
	],
	"./az/_lib/localize/index.js": [
		79557,
		7,
		79557
	],
	"./az/_lib/match/index.js": [
		74390,
		7,
		74390
	],
	"./az/index.js": [
		77356,
		7,
		77356
	],
	"./be-tarask/_lib/formatDistance/index.js": [
		45515,
		7,
		45515
	],
	"./be-tarask/_lib/formatLong/index.js": [
		49505,
		7,
		49505
	],
	"./be-tarask/_lib/formatRelative/index.js": [
		37233,
		7,
		55827,
		37233
	],
	"./be-tarask/_lib/localize/index.js": [
		22623,
		7,
		22623
	],
	"./be-tarask/_lib/match/index.js": [
		96427,
		7,
		96427
	],
	"./be-tarask/index.js": [
		53336,
		7,
		55827,
		53336
	],
	"./be/_lib/formatDistance/index.js": [
		564,
		7,
		564
	],
	"./be/_lib/formatLong/index.js": [
		87682,
		7,
		87682
	],
	"./be/_lib/formatRelative/index.js": [
		28206,
		7,
		55827,
		28206
	],
	"./be/_lib/localize/index.js": [
		13533,
		7,
		13533
	],
	"./be/_lib/match/index.js": [
		71682,
		7,
		71682
	],
	"./be/index.js": [
		9624,
		7,
		55827,
		9624
	],
	"./bg/_lib/formatDistance/index.js": [
		79681,
		7,
		79681
	],
	"./bg/_lib/formatLong/index.js": [
		45930,
		7,
		45930
	],
	"./bg/_lib/formatRelative/index.js": [
		21185,
		7,
		21185
	],
	"./bg/_lib/localize/index.js": [
		91641,
		7,
		91641
	],
	"./bg/_lib/match/index.js": [
		45152,
		7,
		45152
	],
	"./bg/index.js": [
		94719,
		7,
		94719
	],
	"./bn/_lib/formatDistance/index.js": [
		67835,
		7,
		67835
	],
	"./bn/_lib/formatLong/index.js": [
		32076,
		7,
		32076
	],
	"./bn/_lib/formatRelative/index.js": [
		36520,
		7,
		36520
	],
	"./bn/_lib/localize/index.js": [
		12674,
		9,
		12674
	],
	"./bn/_lib/match/index.js": [
		35920,
		7,
		35920
	],
	"./bn/index.js": [
		3628,
		7,
		82182
	],
	"./bs/_lib/formatDistance/index.js": [
		95963,
		7,
		95963
	],
	"./bs/_lib/formatLong/index.js": [
		25711,
		7,
		25711
	],
	"./bs/_lib/formatRelative/index.js": [
		44374,
		7,
		44374
	],
	"./bs/_lib/localize/index.js": [
		28113,
		7,
		28113
	],
	"./bs/_lib/match/index.js": [
		69866,
		7,
		62729
	],
	"./bs/index.js": [
		32181,
		7,
		32181
	],
	"./ca/_lib/formatDistance/index.js": [
		49280,
		7,
		49280
	],
	"./ca/_lib/formatLong/index.js": [
		16686,
		7,
		16686
	],
	"./ca/_lib/formatRelative/index.js": [
		54470,
		7,
		54470
	],
	"./ca/_lib/localize/index.js": [
		50683,
		7,
		50683
	],
	"./ca/_lib/match/index.js": [
		73146,
		7,
		73146
	],
	"./ca/index.js": [
		44732,
		7,
		44732
	],
	"./cs/_lib/formatDistance/index.js": [
		79434,
		7,
		79434
	],
	"./cs/_lib/formatLong/index.js": [
		18336,
		7,
		18336
	],
	"./cs/_lib/formatRelative/index.js": [
		3003,
		7,
		3003
	],
	"./cs/_lib/localize/index.js": [
		48793,
		7,
		48793
	],
	"./cs/_lib/match/index.js": [
		63626,
		7,
		63626
	],
	"./cs/index.js": [
		76105,
		7,
		76105
	],
	"./cy/_lib/formatDistance/index.js": [
		90305,
		7,
		90305
	],
	"./cy/_lib/formatLong/index.js": [
		32132,
		7,
		32132
	],
	"./cy/_lib/formatRelative/index.js": [
		68527,
		7,
		68527
	],
	"./cy/_lib/localize/index.js": [
		17863,
		7,
		17863
	],
	"./cy/_lib/match/index.js": [
		53494,
		7,
		53494
	],
	"./cy/index.js": [
		96227,
		7,
		96227
	],
	"./da/_lib/formatDistance/index.js": [
		96569,
		7,
		96569
	],
	"./da/_lib/formatLong/index.js": [
		20658,
		7,
		20658
	],
	"./da/_lib/formatRelative/index.js": [
		31002,
		7,
		31002
	],
	"./da/_lib/localize/index.js": [
		55578,
		7,
		55578
	],
	"./da/_lib/match/index.js": [
		3393,
		7,
		3393
	],
	"./da/index.js": [
		80925,
		7,
		80925
	],
	"./de-AT/_lib/localize/index.js": [
		56443,
		7,
		56443
	],
	"./de-AT/index.js": [
		73210,
		7,
		73210
	],
	"./de/_lib/formatDistance/index.js": [
		82376,
		7,
		82376
	],
	"./de/_lib/formatLong/index.js": [
		6749,
		7,
		6749
	],
	"./de/_lib/formatRelative/index.js": [
		91805,
		7,
		91805
	],
	"./de/_lib/localize/index.js": [
		56105,
		7,
		56105
	],
	"./de/_lib/match/index.js": [
		83996,
		7,
		83996
	],
	"./de/index.js": [
		76119,
		7,
		76119
	],
	"./el/_lib/formatDistance/index.js": [
		96170,
		7,
		96170
	],
	"./el/_lib/formatLong/index.js": [
		22761,
		7,
		22761
	],
	"./el/_lib/formatRelative/index.js": [
		5093,
		7,
		5093
	],
	"./el/_lib/localize/index.js": [
		79919,
		7,
		79919
	],
	"./el/_lib/match/index.js": [
		20320,
		7,
		20320
	],
	"./el/index.js": [
		71511,
		7,
		71511
	],
	"./en-AU/_lib/formatLong/index.js": [
		47483,
		7,
		47483
	],
	"./en-AU/index.js": [
		51971,
		7,
		51971
	],
	"./en-CA/_lib/formatDistance/index.js": [
		16925,
		7,
		16925
	],
	"./en-CA/_lib/formatLong/index.js": [
		17156,
		7,
		17156
	],
	"./en-CA/index.js": [
		23654,
		7,
		23654
	],
	"./en-GB/_lib/formatLong/index.js": [
		90125,
		7,
		90125
	],
	"./en-GB/index.js": [
		22709,
		7,
		22709
	],
	"./en-IE/index.js": [
		84511,
		7,
		84511
	],
	"./en-IN/_lib/formatLong/index.js": [
		44649,
		7,
		44649
	],
	"./en-IN/index.js": [
		56635,
		7,
		56635
	],
	"./en-NZ/_lib/formatLong/index.js": [
		88738,
		7,
		88738
	],
	"./en-NZ/index.js": [
		3557,
		7,
		3557
	],
	"./en-US/_lib/formatDistance/index.js": [
		71924,
		7,
		71924
	],
	"./en-US/_lib/formatLong/index.js": [
		76469,
		7,
		95062
	],
	"./en-US/_lib/formatRelative/index.js": [
		5102,
		7,
		5102
	],
	"./en-US/_lib/localize/index.js": [
		87839,
		7,
		87839
	],
	"./en-US/_lib/match/index.js": [
		9796,
		7,
		9796
	],
	"./en-US/index.js": [
		82512,
		7,
		82512
	],
	"./en-ZA/_lib/formatLong/index.js": [
		12820,
		7,
		12820
	],
	"./en-ZA/index.js": [
		55585,
		7,
		55585
	],
	"./eo/_lib/formatDistance/index.js": [
		60509,
		7,
		60509
	],
	"./eo/_lib/formatLong/index.js": [
		61709,
		7,
		61709
	],
	"./eo/_lib/formatRelative/index.js": [
		76297,
		7,
		76297
	],
	"./eo/_lib/localize/index.js": [
		83419,
		7,
		83419
	],
	"./eo/_lib/match/index.js": [
		66460,
		7,
		66460
	],
	"./eo/index.js": [
		46050,
		7,
		46050
	],
	"./es/_lib/formatDistance/index.js": [
		17308,
		7,
		17308
	],
	"./es/_lib/formatLong/index.js": [
		19983,
		7,
		19983
	],
	"./es/_lib/formatRelative/index.js": [
		54011,
		7,
		54011
	],
	"./es/_lib/localize/index.js": [
		389,
		7,
		389
	],
	"./es/_lib/match/index.js": [
		71365,
		7,
		71365
	],
	"./es/index.js": [
		19962,
		7,
		19962
	],
	"./et/_lib/formatDistance/index.js": [
		37961,
		7,
		37961
	],
	"./et/_lib/formatLong/index.js": [
		50363,
		7,
		50363
	],
	"./et/_lib/formatRelative/index.js": [
		87335,
		7,
		87335
	],
	"./et/_lib/localize/index.js": [
		50794,
		7,
		50794
	],
	"./et/_lib/match/index.js": [
		60084,
		7,
		60084
	],
	"./et/index.js": [
		58170,
		7,
		58170
	],
	"./eu/_lib/formatDistance/index.js": [
		85454,
		7,
		85454
	],
	"./eu/_lib/formatLong/index.js": [
		56183,
		7,
		56183
	],
	"./eu/_lib/formatRelative/index.js": [
		94237,
		7,
		94237
	],
	"./eu/_lib/localize/index.js": [
		5966,
		7,
		5966
	],
	"./eu/_lib/match/index.js": [
		64402,
		7,
		64402
	],
	"./eu/index.js": [
		9042,
		7,
		9042
	],
	"./fa-IR/_lib/formatDistance/index.js": [
		87201,
		7,
		87201
	],
	"./fa-IR/_lib/formatLong/index.js": [
		81884,
		7,
		81884
	],
	"./fa-IR/_lib/formatRelative/index.js": [
		91912,
		7,
		91912
	],
	"./fa-IR/_lib/localize/index.js": [
		97188,
		7,
		97188
	],
	"./fa-IR/_lib/match/index.js": [
		43043,
		7,
		43043
	],
	"./fa-IR/index.js": [
		13537,
		7,
		13537
	],
	"./fi/_lib/formatDistance/index.js": [
		67380,
		7,
		67380
	],
	"./fi/_lib/formatLong/index.js": [
		99532,
		7,
		99532
	],
	"./fi/_lib/formatRelative/index.js": [
		15561,
		7,
		15561
	],
	"./fi/_lib/localize/index.js": [
		64354,
		7,
		61622
	],
	"./fi/_lib/match/index.js": [
		27530,
		7,
		27530
	],
	"./fi/index.js": [
		95999,
		7,
		95999
	],
	"./fr-CA/_lib/formatLong/index.js": [
		53860,
		7,
		53860
	],
	"./fr-CA/index.js": [
		82580,
		7,
		82580
	],
	"./fr-CH/_lib/formatLong/index.js": [
		96065,
		7,
		96065
	],
	"./fr-CH/_lib/formatRelative/index.js": [
		16372,
		7,
		16372
	],
	"./fr-CH/index.js": [
		89718,
		7,
		89718
	],
	"./fr/_lib/formatDistance/index.js": [
		66522,
		7,
		66522
	],
	"./fr/_lib/formatLong/index.js": [
		34325,
		7,
		34325
	],
	"./fr/_lib/formatRelative/index.js": [
		22162,
		7,
		22162
	],
	"./fr/_lib/localize/index.js": [
		38803,
		7,
		38803
	],
	"./fr/_lib/match/index.js": [
		58213,
		7,
		58213
	],
	"./fr/index.js": [
		63126,
		7,
		63126
	],
	"./fy/_lib/formatDistance/index.js": [
		36945,
		7,
		36945
	],
	"./fy/_lib/formatLong/index.js": [
		84905,
		7,
		84905
	],
	"./fy/_lib/formatRelative/index.js": [
		50776,
		7,
		50776
	],
	"./fy/_lib/localize/index.js": [
		82930,
		7,
		82930
	],
	"./fy/_lib/match/index.js": [
		98756,
		7,
		98756
	],
	"./fy/index.js": [
		8848,
		7,
		8848
	],
	"./gd/_lib/formatDistance/index.js": [
		52646,
		7,
		52646
	],
	"./gd/_lib/formatLong/index.js": [
		88030,
		7,
		88030
	],
	"./gd/_lib/formatRelative/index.js": [
		11398,
		7,
		11398
	],
	"./gd/_lib/localize/index.js": [
		77390,
		7,
		77390
	],
	"./gd/_lib/match/index.js": [
		34044,
		7,
		34044
	],
	"./gd/index.js": [
		93698,
		7,
		93698
	],
	"./gl/_lib/formatDistance/index.js": [
		22523,
		7,
		22523
	],
	"./gl/_lib/formatLong/index.js": [
		75618,
		7,
		75618
	],
	"./gl/_lib/formatRelative/index.js": [
		2698,
		7,
		2698
	],
	"./gl/_lib/localize/index.js": [
		68154,
		7,
		68154
	],
	"./gl/_lib/match/index.js": [
		27475,
		7,
		27475
	],
	"./gl/index.js": [
		68846,
		7,
		68846
	],
	"./gu/_lib/formatDistance/index.js": [
		22933,
		7,
		22933
	],
	"./gu/_lib/formatLong/index.js": [
		82513,
		7,
		82513
	],
	"./gu/_lib/formatRelative/index.js": [
		46840,
		7,
		46840
	],
	"./gu/_lib/localize/index.js": [
		98528,
		7,
		98528
	],
	"./gu/_lib/match/index.js": [
		18201,
		7,
		73691
	],
	"./gu/index.js": [
		56209,
		7,
		56209
	],
	"./he/_lib/formatDistance/index.js": [
		75736,
		7,
		75736
	],
	"./he/_lib/formatLong/index.js": [
		45218,
		7,
		45218
	],
	"./he/_lib/formatRelative/index.js": [
		64125,
		7,
		64125
	],
	"./he/_lib/localize/index.js": [
		20379,
		7,
		20379
	],
	"./he/_lib/match/index.js": [
		15430,
		7,
		15430
	],
	"./he/index.js": [
		16309,
		7,
		16309
	],
	"./hi/_lib/formatDistance/index.js": [
		51734,
		7,
		51734
	],
	"./hi/_lib/formatLong/index.js": [
		78241,
		7,
		78241
	],
	"./hi/_lib/formatRelative/index.js": [
		56683,
		7,
		56683
	],
	"./hi/_lib/localize/index.js": [
		65282,
		9,
		65282
	],
	"./hi/_lib/match/index.js": [
		50248,
		7,
		50248
	],
	"./hi/index.js": [
		37056,
		7,
		37056
	],
	"./hr/_lib/formatDistance/index.js": [
		7792,
		7,
		57507
	],
	"./hr/_lib/formatLong/index.js": [
		77910,
		7,
		77910
	],
	"./hr/_lib/formatRelative/index.js": [
		45339,
		7,
		45339
	],
	"./hr/_lib/localize/index.js": [
		77677,
		7,
		77677
	],
	"./hr/_lib/match/index.js": [
		16436,
		7,
		16436
	],
	"./hr/index.js": [
		97276,
		7,
		97276
	],
	"./ht/_lib/formatDistance/index.js": [
		61245,
		7,
		61245
	],
	"./ht/_lib/formatLong/index.js": [
		67737,
		7,
		67737
	],
	"./ht/_lib/formatRelative/index.js": [
		39803,
		7,
		39803
	],
	"./ht/_lib/localize/index.js": [
		19400,
		7,
		19400
	],
	"./ht/_lib/match/index.js": [
		97695,
		7,
		97695
	],
	"./ht/index.js": [
		55389,
		7,
		55389
	],
	"./hu/_lib/formatDistance/index.js": [
		91898,
		7,
		91898
	],
	"./hu/_lib/formatLong/index.js": [
		19266,
		7,
		19266
	],
	"./hu/_lib/formatRelative/index.js": [
		41544,
		7,
		41544
	],
	"./hu/_lib/localize/index.js": [
		69353,
		7,
		69353
	],
	"./hu/_lib/match/index.js": [
		85370,
		7,
		85370
	],
	"./hu/index.js": [
		79675,
		7,
		79675
	],
	"./hy/_lib/formatDistance/index.js": [
		41839,
		7,
		41839
	],
	"./hy/_lib/formatLong/index.js": [
		45625,
		7,
		45625
	],
	"./hy/_lib/formatRelative/index.js": [
		80528,
		7,
		80528
	],
	"./hy/_lib/localize/index.js": [
		74391,
		7,
		74391
	],
	"./hy/_lib/match/index.js": [
		1824,
		7,
		1824
	],
	"./hy/index.js": [
		74403,
		7,
		74403
	],
	"./id/_lib/formatDistance/index.js": [
		95223,
		7,
		95223
	],
	"./id/_lib/formatLong/index.js": [
		27166,
		7,
		27166
	],
	"./id/_lib/formatRelative/index.js": [
		65673,
		7,
		65673
	],
	"./id/_lib/localize/index.js": [
		98045,
		7,
		98045
	],
	"./id/_lib/match/index.js": [
		10798,
		7,
		10798
	],
	"./id/index.js": [
		51872,
		7,
		51872
	],
	"./is/_lib/formatDistance/index.js": [
		67527,
		7,
		67527
	],
	"./is/_lib/formatLong/index.js": [
		73003,
		7,
		73003
	],
	"./is/_lib/formatRelative/index.js": [
		75440,
		7,
		75440
	],
	"./is/_lib/localize/index.js": [
		53162,
		7,
		53162
	],
	"./is/_lib/match/index.js": [
		75101,
		7,
		75101
	],
	"./is/index.js": [
		28677,
		7,
		28677
	],
	"./it-CH/_lib/formatLong/index.js": [
		98347,
		7,
		98347
	],
	"./it-CH/index.js": [
		12264,
		7,
		12264
	],
	"./it/_lib/formatDistance/index.js": [
		12642,
		7,
		12642
	],
	"./it/_lib/formatLong/index.js": [
		96714,
		7,
		96714
	],
	"./it/_lib/formatRelative/index.js": [
		74501,
		7,
		74501
	],
	"./it/_lib/localize/index.js": [
		82713,
		7,
		82713
	],
	"./it/_lib/match/index.js": [
		37281,
		7,
		37281
	],
	"./it/index.js": [
		59629,
		7,
		59629
	],
	"./ja-Hira/_lib/formatDistance/index.js": [
		65047,
		7,
		65047
	],
	"./ja-Hira/_lib/formatLong/index.js": [
		44818,
		7,
		44818
	],
	"./ja-Hira/_lib/formatRelative/index.js": [
		20942,
		7,
		20942
	],
	"./ja-Hira/_lib/localize/index.js": [
		97031,
		7,
		97031
	],
	"./ja-Hira/_lib/match/index.js": [
		71636,
		7,
		71636
	],
	"./ja-Hira/index.js": [
		81590,
		7,
		81590
	],
	"./ja/_lib/formatDistance/index.js": [
		15525,
		7,
		15525
	],
	"./ja/_lib/formatLong/index.js": [
		45161,
		7,
		45161
	],
	"./ja/_lib/formatRelative/index.js": [
		85071,
		7,
		85071
	],
	"./ja/_lib/localize/index.js": [
		85598,
		7,
		85598
	],
	"./ja/_lib/match/index.js": [
		93509,
		7,
		93509
	],
	"./ja/index.js": [
		42180,
		7,
		42180
	],
	"./ka/_lib/formatDistance/index.js": [
		87414,
		7,
		87414
	],
	"./ka/_lib/formatLong/index.js": [
		27355,
		7,
		27355
	],
	"./ka/_lib/formatRelative/index.js": [
		91402,
		7,
		91402
	],
	"./ka/_lib/localize/index.js": [
		5552,
		7,
		5552
	],
	"./ka/_lib/match/index.js": [
		33706,
		7,
		75108
	],
	"./ka/index.js": [
		36501,
		7,
		36501
	],
	"./kk/_lib/formatDistance/index.js": [
		52071,
		7,
		52071
	],
	"./kk/_lib/formatLong/index.js": [
		99466,
		7,
		99466
	],
	"./kk/_lib/formatRelative/index.js": [
		52400,
		7,
		52400
	],
	"./kk/_lib/localize/index.js": [
		31814,
		7,
		31814
	],
	"./kk/_lib/match/index.js": [
		5574,
		7,
		5574
	],
	"./kk/index.js": [
		34996,
		7,
		34996
	],
	"./km/_lib/formatDistance/index.js": [
		97263,
		7,
		97263
	],
	"./km/_lib/formatLong/index.js": [
		66355,
		7,
		66355
	],
	"./km/_lib/formatRelative/index.js": [
		34833,
		7,
		34833
	],
	"./km/_lib/localize/index.js": [
		99273,
		7,
		99273
	],
	"./km/_lib/match/index.js": [
		7916,
		7,
		7916
	],
	"./km/index.js": [
		38684,
		7,
		38684
	],
	"./kn/_lib/formatDistance/index.js": [
		56071,
		7,
		56071
	],
	"./kn/_lib/formatLong/index.js": [
		78505,
		7,
		78505
	],
	"./kn/_lib/formatRelative/index.js": [
		8440,
		7,
		8440
	],
	"./kn/_lib/localize/index.js": [
		23283,
		7,
		23283
	],
	"./kn/_lib/match/index.js": [
		27211,
		7,
		27211
	],
	"./kn/index.js": [
		43434,
		7,
		43434
	],
	"./ko/_lib/formatDistance/index.js": [
		36136,
		7,
		36136
	],
	"./ko/_lib/formatLong/index.js": [
		91257,
		7,
		91257
	],
	"./ko/_lib/formatRelative/index.js": [
		52593,
		7,
		52593
	],
	"./ko/_lib/localize/index.js": [
		93558,
		7,
		93558
	],
	"./ko/_lib/match/index.js": [
		97948,
		7,
		97948
	],
	"./ko/index.js": [
		2666,
		7,
		2666
	],
	"./lb/_lib/formatDistance/index.js": [
		40714,
		7,
		40714
	],
	"./lb/_lib/formatLong/index.js": [
		73815,
		7,
		73815
	],
	"./lb/_lib/formatRelative/index.js": [
		1395,
		7,
		1395
	],
	"./lb/_lib/localize/index.js": [
		45973,
		7,
		45973
	],
	"./lb/_lib/match/index.js": [
		34308,
		7,
		34308
	],
	"./lb/index.js": [
		84048,
		7,
		84048
	],
	"./lt/_lib/formatDistance/index.js": [
		42067,
		7,
		42067
	],
	"./lt/_lib/formatLong/index.js": [
		83573,
		7,
		83573
	],
	"./lt/_lib/formatRelative/index.js": [
		63963,
		7,
		63963
	],
	"./lt/_lib/localize/index.js": [
		16687,
		7,
		16687
	],
	"./lt/_lib/match/index.js": [
		79884,
		7,
		79884
	],
	"./lt/index.js": [
		2536,
		7,
		2536
	],
	"./lv/_lib/formatDistance/index.js": [
		41340,
		7,
		41340
	],
	"./lv/_lib/formatLong/index.js": [
		47090,
		7,
		47090
	],
	"./lv/_lib/formatRelative/index.js": [
		54550,
		7,
		54550
	],
	"./lv/_lib/localize/index.js": [
		44306,
		7,
		44306
	],
	"./lv/_lib/match/index.js": [
		94305,
		7,
		94305
	],
	"./lv/index.js": [
		3610,
		7,
		3610
	],
	"./mk/_lib/formatDistance/index.js": [
		83350,
		7,
		83350
	],
	"./mk/_lib/formatLong/index.js": [
		30299,
		7,
		30299
	],
	"./mk/_lib/formatRelative/index.js": [
		21154,
		7,
		21154
	],
	"./mk/_lib/localize/index.js": [
		49324,
		7,
		49324
	],
	"./mk/_lib/match/index.js": [
		45603,
		7,
		45603
	],
	"./mk/index.js": [
		1057,
		7,
		1057
	],
	"./mn/_lib/formatDistance/index.js": [
		64216,
		7,
		64216
	],
	"./mn/_lib/formatLong/index.js": [
		10562,
		7,
		10562
	],
	"./mn/_lib/formatRelative/index.js": [
		69683,
		7,
		69683
	],
	"./mn/_lib/localize/index.js": [
		48637,
		7,
		94476
	],
	"./mn/_lib/match/index.js": [
		64094,
		7,
		64094
	],
	"./mn/index.js": [
		14893,
		7,
		14893
	],
	"./ms/_lib/formatDistance/index.js": [
		79522,
		7,
		79522
	],
	"./ms/_lib/formatLong/index.js": [
		14333,
		7,
		14333
	],
	"./ms/_lib/formatRelative/index.js": [
		51140,
		7,
		51140
	],
	"./ms/_lib/localize/index.js": [
		97118,
		7,
		97118
	],
	"./ms/_lib/match/index.js": [
		14396,
		7,
		14396
	],
	"./ms/index.js": [
		83148,
		7,
		83148
	],
	"./mt/_lib/formatDistance/index.js": [
		92252,
		7,
		92252
	],
	"./mt/_lib/formatLong/index.js": [
		64778,
		7,
		64778
	],
	"./mt/_lib/formatRelative/index.js": [
		69682,
		7,
		69682
	],
	"./mt/_lib/localize/index.js": [
		57669,
		7,
		57669
	],
	"./mt/_lib/match/index.js": [
		7438,
		7,
		7438
	],
	"./mt/index.js": [
		22598,
		7,
		22598
	],
	"./nb/_lib/formatDistance/index.js": [
		5979,
		7,
		5979
	],
	"./nb/_lib/formatLong/index.js": [
		54727,
		7,
		54727
	],
	"./nb/_lib/formatRelative/index.js": [
		91423,
		7,
		91423
	],
	"./nb/_lib/localize/index.js": [
		99726,
		7,
		99726
	],
	"./nb/_lib/match/index.js": [
		38558,
		7,
		38558
	],
	"./nb/index.js": [
		46815,
		7,
		46815
	],
	"./nl-BE/_lib/formatDistance/index.js": [
		70218,
		7,
		70218
	],
	"./nl-BE/_lib/formatLong/index.js": [
		14661,
		7,
		14661
	],
	"./nl-BE/_lib/formatRelative/index.js": [
		51573,
		7,
		51573
	],
	"./nl-BE/_lib/localize/index.js": [
		20174,
		7,
		20174
	],
	"./nl-BE/_lib/match/index.js": [
		68933,
		7,
		87601
	],
	"./nl-BE/index.js": [
		25778,
		7,
		25778
	],
	"./nl/_lib/formatDistance/index.js": [
		98562,
		7,
		98562
	],
	"./nl/_lib/formatLong/index.js": [
		30221,
		7,
		30221
	],
	"./nl/_lib/formatRelative/index.js": [
		96665,
		7,
		96665
	],
	"./nl/_lib/localize/index.js": [
		90384,
		7,
		90384
	],
	"./nl/_lib/match/index.js": [
		15009,
		7,
		15009
	],
	"./nl/index.js": [
		70390,
		7,
		70390
	],
	"./nn/_lib/formatDistance/index.js": [
		49714,
		7,
		49714
	],
	"./nn/_lib/formatLong/index.js": [
		29983,
		7,
		29983
	],
	"./nn/_lib/formatRelative/index.js": [
		35458,
		7,
		35458
	],
	"./nn/_lib/localize/index.js": [
		87563,
		7,
		87563
	],
	"./nn/_lib/match/index.js": [
		12324,
		7,
		12324
	],
	"./nn/index.js": [
		72495,
		7,
		72495
	],
	"./oc/_lib/formatDistance/index.js": [
		77553,
		7,
		77553
	],
	"./oc/_lib/formatLong/index.js": [
		79329,
		7,
		79329
	],
	"./oc/_lib/formatRelative/index.js": [
		10556,
		7,
		10556
	],
	"./oc/_lib/localize/index.js": [
		86354,
		7,
		86354
	],
	"./oc/_lib/match/index.js": [
		23180,
		7,
		23180
	],
	"./oc/index.js": [
		3824,
		7,
		3824
	],
	"./pl/_lib/formatDistance/index.js": [
		7325,
		7,
		7325
	],
	"./pl/_lib/formatLong/index.js": [
		50807,
		7,
		50807
	],
	"./pl/_lib/formatRelative/index.js": [
		66002,
		7,
		66002
	],
	"./pl/_lib/localize/index.js": [
		12885,
		7,
		12885
	],
	"./pl/_lib/match/index.js": [
		84817,
		7,
		84817
	],
	"./pl/index.js": [
		63618,
		7,
		63618
	],
	"./pt-BR/_lib/formatDistance/index.js": [
		38877,
		7,
		38877
	],
	"./pt-BR/_lib/formatLong/index.js": [
		23903,
		7,
		23903
	],
	"./pt-BR/_lib/formatRelative/index.js": [
		41897,
		7,
		41897
	],
	"./pt-BR/_lib/localize/index.js": [
		78076,
		7,
		78076
	],
	"./pt-BR/_lib/match/index.js": [
		13550,
		7,
		13550
	],
	"./pt-BR/index.js": [
		81333,
		7,
		81333
	],
	"./pt/_lib/formatDistance/index.js": [
		1092,
		7,
		48637
	],
	"./pt/_lib/formatLong/index.js": [
		10063,
		7,
		10063
	],
	"./pt/_lib/formatRelative/index.js": [
		29479,
		7,
		29479
	],
	"./pt/_lib/localize/index.js": [
		81235,
		7,
		81235
	],
	"./pt/_lib/match/index.js": [
		51549,
		7,
		51549
	],
	"./pt/index.js": [
		63086,
		7,
		63086
	],
	"./ro/_lib/formatDistance/index.js": [
		6666,
		7,
		6666
	],
	"./ro/_lib/formatLong/index.js": [
		60333,
		7,
		60333
	],
	"./ro/_lib/formatRelative/index.js": [
		67125,
		7,
		67125
	],
	"./ro/_lib/localize/index.js": [
		39408,
		7,
		39408
	],
	"./ro/_lib/match/index.js": [
		9480,
		7,
		9480
	],
	"./ro/index.js": [
		66088,
		7,
		66088
	],
	"./ru/_lib/formatDistance/index.js": [
		88770,
		7,
		88770
	],
	"./ru/_lib/formatLong/index.js": [
		83233,
		7,
		83233
	],
	"./ru/_lib/formatRelative/index.js": [
		53566,
		7,
		53566
	],
	"./ru/_lib/localize/index.js": [
		81348,
		7,
		81348
	],
	"./ru/_lib/match/index.js": [
		45195,
		7,
		45195
	],
	"./ru/index.js": [
		66754,
		7,
		66754
	],
	"./sk/_lib/formatDistance/index.js": [
		46732,
		7,
		46732
	],
	"./sk/_lib/formatLong/index.js": [
		21831,
		7,
		21831
	],
	"./sk/_lib/formatRelative/index.js": [
		50560,
		7,
		50560
	],
	"./sk/_lib/localize/index.js": [
		31044,
		7,
		31044
	],
	"./sk/_lib/match/index.js": [
		58923,
		7,
		58923
	],
	"./sk/index.js": [
		78259,
		7,
		78259
	],
	"./sl/_lib/formatDistance/index.js": [
		76930,
		7,
		76930
	],
	"./sl/_lib/formatLong/index.js": [
		9273,
		7,
		9273
	],
	"./sl/_lib/formatRelative/index.js": [
		83070,
		7,
		83070
	],
	"./sl/_lib/localize/index.js": [
		42958,
		7,
		42958
	],
	"./sl/_lib/match/index.js": [
		83296,
		7,
		83296
	],
	"./sl/index.js": [
		1139,
		7,
		1139
	],
	"./sq/_lib/formatDistance/index.js": [
		36794,
		7,
		36794
	],
	"./sq/_lib/formatLong/index.js": [
		62624,
		7,
		62624
	],
	"./sq/_lib/formatRelative/index.js": [
		19232,
		7,
		19232
	],
	"./sq/_lib/localize/index.js": [
		76880,
		7,
		76880
	],
	"./sq/_lib/match/index.js": [
		57930,
		7,
		57930
	],
	"./sq/index.js": [
		43852,
		7,
		43852
	],
	"./sr-Latn/_lib/formatDistance/index.js": [
		26261,
		7,
		26261
	],
	"./sr-Latn/_lib/formatLong/index.js": [
		40214,
		7,
		40214
	],
	"./sr-Latn/_lib/formatRelative/index.js": [
		619,
		7,
		619
	],
	"./sr-Latn/_lib/localize/index.js": [
		25494,
		7,
		25494
	],
	"./sr-Latn/_lib/match/index.js": [
		70091,
		7,
		70091
	],
	"./sr-Latn/index.js": [
		62394,
		7,
		62394
	],
	"./sr/_lib/formatDistance/index.js": [
		94963,
		7,
		94963
	],
	"./sr/_lib/formatLong/index.js": [
		9572,
		7,
		9572
	],
	"./sr/_lib/formatRelative/index.js": [
		32195,
		7,
		32195
	],
	"./sr/_lib/localize/index.js": [
		63747,
		7,
		63747
	],
	"./sr/_lib/match/index.js": [
		59555,
		7,
		59555
	],
	"./sr/index.js": [
		32397,
		7,
		32397
	],
	"./sv/_lib/formatDistance/index.js": [
		93283,
		7,
		93283
	],
	"./sv/_lib/formatLong/index.js": [
		45853,
		7,
		45853
	],
	"./sv/_lib/formatRelative/index.js": [
		46304,
		7,
		46304
	],
	"./sv/_lib/localize/index.js": [
		62185,
		7,
		62185
	],
	"./sv/_lib/match/index.js": [
		31379,
		7,
		31379
	],
	"./sv/index.js": [
		29779,
		7,
		29779
	],
	"./ta/_lib/formatDistance/index.js": [
		74639,
		7,
		74639
	],
	"./ta/_lib/formatLong/index.js": [
		83101,
		7,
		83101
	],
	"./ta/_lib/formatRelative/index.js": [
		14179,
		7,
		14179
	],
	"./ta/_lib/localize/index.js": [
		88574,
		7,
		88574
	],
	"./ta/_lib/match/index.js": [
		6042,
		7,
		6042
	],
	"./ta/index.js": [
		32718,
		7,
		32718
	],
	"./te/_lib/formatDistance/index.js": [
		15919,
		7,
		15919
	],
	"./te/_lib/formatLong/index.js": [
		23003,
		7,
		23003
	],
	"./te/_lib/formatRelative/index.js": [
		15927,
		7,
		15927
	],
	"./te/_lib/localize/index.js": [
		28739,
		7,
		28739
	],
	"./te/_lib/match/index.js": [
		46028,
		7,
		46028
	],
	"./te/index.js": [
		52275,
		7,
		52275
	],
	"./th/_lib/formatDistance/index.js": [
		73448,
		7,
		73448
	],
	"./th/_lib/formatLong/index.js": [
		29011,
		7,
		29011
	],
	"./th/_lib/formatRelative/index.js": [
		46945,
		7,
		46945
	],
	"./th/_lib/localize/index.js": [
		44017,
		7,
		44017
	],
	"./th/_lib/match/index.js": [
		65534,
		7,
		65534
	],
	"./th/index.js": [
		98492,
		7,
		98492
	],
	"./tr/_lib/formatDistance/index.js": [
		91742,
		7,
		91742
	],
	"./tr/_lib/formatLong/index.js": [
		66075,
		7,
		66075
	],
	"./tr/_lib/formatRelative/index.js": [
		38897,
		7,
		38897
	],
	"./tr/_lib/localize/index.js": [
		81281,
		7,
		81281
	],
	"./tr/_lib/match/index.js": [
		20941,
		7,
		20941
	],
	"./tr/index.js": [
		41062,
		7,
		41062
	],
	"./ug/_lib/formatDistance/index.js": [
		31914,
		7,
		31914
	],
	"./ug/_lib/formatLong/index.js": [
		70065,
		7,
		70065
	],
	"./ug/_lib/formatRelative/index.js": [
		4128,
		7,
		4128
	],
	"./ug/_lib/localize/index.js": [
		19758,
		7,
		19758
	],
	"./ug/_lib/match/index.js": [
		60663,
		7,
		60663
	],
	"./ug/index.js": [
		61505,
		7,
		61505
	],
	"./uk/_lib/formatDistance/index.js": [
		2647,
		7,
		2647
	],
	"./uk/_lib/formatLong/index.js": [
		71831,
		7,
		71831
	],
	"./uk/_lib/formatRelative/index.js": [
		80507,
		7,
		55827,
		80507
	],
	"./uk/_lib/localize/index.js": [
		31882,
		7,
		31882
	],
	"./uk/_lib/match/index.js": [
		88845,
		7,
		88845
	],
	"./uk/index.js": [
		25490,
		7,
		55827,
		25490
	],
	"./uz-Cyrl/_lib/formatDistance/index.js": [
		59074,
		7,
		59074
	],
	"./uz-Cyrl/_lib/formatLong/index.js": [
		16798,
		7,
		16798
	],
	"./uz-Cyrl/_lib/formatRelative/index.js": [
		65283,
		7,
		65283
	],
	"./uz-Cyrl/_lib/localize/index.js": [
		10755,
		7,
		10755
	],
	"./uz-Cyrl/_lib/match/index.js": [
		56523,
		7,
		56523
	],
	"./uz-Cyrl/index.js": [
		93757,
		7,
		93757
	],
	"./uz/_lib/formatDistance/index.js": [
		55965,
		7,
		55965
	],
	"./uz/_lib/formatLong/index.js": [
		59606,
		7,
		59606
	],
	"./uz/_lib/formatRelative/index.js": [
		81632,
		7,
		81632
	],
	"./uz/_lib/localize/index.js": [
		52970,
		7,
		52970
	],
	"./uz/_lib/match/index.js": [
		29633,
		7,
		29633
	],
	"./uz/index.js": [
		26466,
		7,
		26466
	],
	"./vi/_lib/formatDistance/index.js": [
		72198,
		7,
		72198
	],
	"./vi/_lib/formatLong/index.js": [
		32592,
		7,
		32592
	],
	"./vi/_lib/formatRelative/index.js": [
		20022,
		7,
		20022
	],
	"./vi/_lib/localize/index.js": [
		48125,
		7,
		48125
	],
	"./vi/_lib/match/index.js": [
		8624,
		7,
		8624
	],
	"./vi/index.js": [
		52358,
		7,
		52358
	],
	"./zh-CN/_lib/formatDistance/index.js": [
		31526,
		7,
		31526
	],
	"./zh-CN/_lib/formatLong/index.js": [
		87969,
		7,
		87969
	],
	"./zh-CN/_lib/formatRelative/index.js": [
		6915,
		7,
		6915
	],
	"./zh-CN/_lib/localize/index.js": [
		6890,
		7,
		6890
	],
	"./zh-CN/_lib/match/index.js": [
		95454,
		7,
		95454
	],
	"./zh-CN/index.js": [
		24602,
		7,
		24602
	],
	"./zh-HK/_lib/formatDistance/index.js": [
		84231,
		7,
		84231
	],
	"./zh-HK/_lib/formatLong/index.js": [
		47076,
		7,
		47076
	],
	"./zh-HK/_lib/formatRelative/index.js": [
		53082,
		7,
		53082
	],
	"./zh-HK/_lib/localize/index.js": [
		13653,
		7,
		13653
	],
	"./zh-HK/_lib/match/index.js": [
		88357,
		7,
		88357
	],
	"./zh-HK/index.js": [
		96835,
		7,
		96835
	],
	"./zh-TW/_lib/formatDistance/index.js": [
		63106,
		7,
		63106
	],
	"./zh-TW/_lib/formatLong/index.js": [
		27177,
		7,
		27177
	],
	"./zh-TW/_lib/formatRelative/index.js": [
		13238,
		7,
		13238
	],
	"./zh-TW/_lib/localize/index.js": [
		46341,
		7,
		46341
	],
	"./zh-TW/_lib/match/index.js": [
		7768,
		7,
		7768
	],
	"./zh-TW/index.js": [
		68368,
		7,
		18201
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 71213;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 70454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


var BackButton = function(param) {
    var isAppWebView = param.isAppWebView, _color = param.color, color = _color === void 0 ? "black" : _color, _top = param.top, top = _top === void 0 ? "top-4" : _top, _left = param.left, left = _left === void 0 ? "left-2" : _left;
    return null;
// const router = useRouter();
// if (!isAppWebView) {
//   return null;
// }
// return (
//   <button
//     onClick={() => router.back()}
//     className={`absolute ${top} ${left} sm:left-0 flex p-2 rounded-full backdrop-blur-sm transition-all text-brand-black group z-20`}
//   >
//     <Image
//       src={
//         color == "white"
//           ? "/icons/left-arrow-white.svg"
//           : "/icons/left-arrow.svg"
//       }
//       alt="Geri"
//       width={32}
//       height={32}
//     />
//   </button>
// );
};
/* harmony default export */ __webpack_exports__["Z"] = (BackButton);


/***/ }),

/***/ 3605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _icons_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17601);
/* harmony import */ var _BackButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70454);





var BreadCrumb = function(param) {
    var data = param.data, isAppWebView = param.isAppWebView;
    if (data) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-brand-color-primary lg:bg-brand-blue-2 w-full relative py-4 mb-6 flex items-start gap-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BackButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                isAppWebView: isAppWebView,
                color: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "pl-8 flex flex-col lg:flex-row flex-wrap items-center justify-center lg:justify-between w-full text-white",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-xl mm:text-2xl lg:text-4xl font-medium",
                            children: data.baslik
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: "flex items-center gap-x-2 text-sm mm:text-base mt-1 lg:mt-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_icons__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .J, {
                                    name: "location",
                                    className: "hidden lg:inline-block"
                                }),
                                data.data.map(function(e, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: i > 0 ? "before:content-['/'] before:pr-2" : "",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: e.url,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                title: e.title,
                                                children: e.name
                                            })
                                        })
                                    }, i);
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumb);


/***/ }),

/***/ 16543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var DefaultCurrencyFormat = function(_param) {
    var value = _param.value, Symbol = _param.Symbol, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "value",
        "Symbol"
    ]);
    var obj = {
        "\u20BA": "TRY",
        $: "USD",
        "\u20AC": "EUR",
        "\xa3": "GBP"
    };
    var formattedValue = new Intl.NumberFormat( false ? 0 : "tr-TR", {
        style: "currency",
        currency: obj[Symbol],
        minimumFractionDigits: 0
    }).format(value);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: formattedValue
    });
//return <></>;
//if (Symbol == "₺")
//  return (
//    <CurrencyFormat
//      value={value}
//      displayType={"text"}
//      thousandSeparator={"."}
//      decimalSeparator={","}
//      suffix={Symbol}
//      {...props}
//      renderText={(value) => <>{value}</>}
//    />
//  );
//return (
//  <CurrencyFormat
//    value={value}
//    displayType={"text"}
//    thousandSeparator={"."}
//    decimalSeparator={","}
//    prefix={Symbol}
//    {...props}
//    renderText={(value) => <>{value}</>}
//  />
//);
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultCurrencyFormat);


/***/ }),

/***/ 92235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var FancyBox = function(param) {
    var children = param.children, _options = param.options, options = _options === void 0 ? {} : _options, _delegate = param.delegate, delegate = _delegate === void 0 ? "[data-fancybox]" : _delegate;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), scriptsLoaded = ref[0], setScriptsLoaded = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var loadFancybox = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var link;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // Add CSS
                            if (!document.querySelector('link[href*="fancybox.css"]')) {
                                link = document.createElement("link");
                                link.rel = "stylesheet";
                                link.href = "https://cdn.jsdelivr.net/npm/@fancyapps/ui@5/dist/fancybox/fancybox.css";
                                document.head.appendChild(link);
                            }
                            if (document.querySelector('script[src*="fancybox.umd.js"]')) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                var script = document.createElement("script");
                                script.src = "https://cdn.jsdelivr.net/npm/@fancyapps/ui@5/dist/fancybox/fancybox.umd.js";
                                script.async = true;
                                script.onload = function() {
                                    return resolve(true);
                                };
                                document.body.appendChild(script);
                            }));
                        case 3:
                            return _ctx.abrupt("return", Promise.resolve(true));
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadFancybox() {
                return _ref.apply(this, arguments);
            };
        }();
        loadFancybox().then(function() {
            setScriptsLoaded(true);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (scriptsLoaded && window.Fancybox) {
            // Initialize Fancybox
            window.Fancybox.bind(delegate, options);
            // Cleanup function
            return function() {
                window.Fancybox.destroy();
            };
        }
    }, [
        scriptsLoaded,
        delegate,
        options
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FancyBox);


/***/ }),

/***/ 71700:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var Local = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return "".concat(src, "?quality=").concat(quality || 75);
};
/* harmony default export */ __webpack_exports__["Z"] = (Local);


/***/ }),

/***/ 71593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Blur; }
/* harmony export */ });
var Remote = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    if (width > 1920) width = 1920;
    return "".concat("https://cdn.balayivillasikirala.com.tr", "/uploads/").concat(width, "/").concat(src);
};
var Blur = function(src) {
    return "".concat("https://cdn.balayivillasikirala.com.tr", "/uploads/30/").concat(src);
};
/* harmony default export */ __webpack_exports__["Z"] = (Remote);


/***/ }),

/***/ 22068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pages_Blank; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/BreadCrumb.js
var BreadCrumb = __webpack_require__(3605);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/LoaderRemote.js
var LoaderRemote = __webpack_require__(71593);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/Pages/BankaItem.js





var BankaItem = function(param) {
    var item = param.item;
    var ref = (0,TranslationContext/* useTranslation */.m)(), bankItemBankName = ref.bankItemBankName, bankItemBankBranch = ref.bankItemBankBranch, bankItemBankAccountName = ref.bankItemBankAccountName, bankItemBankIban = ref.bankItemBankIban;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
        className: "table border border-[#ccc] mb-8 w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        rowSpan: 9,
                        className: "w-80 hidden sm:table-cell",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "object-contain w-56 h-40 relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    layout: "fill",
                                    src: item.resim + "?l=0",
                                    loader: LoaderRemote/* default */.Z,
                                    objectFit: "contain",
                                    alt: ""
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        colSpan: 2,
                        className: "w-80 table-cell sm:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "object-contain w-56 h-40 relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    layout: "fill",
                                    src: item.resim + "?l=0",
                                    loader: LoaderRemote/* default */.Z,
                                    objectFit: "contain",
                                    alt: ""
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "p-2 border-t border-[#ccc] border-l border-r font-semibold text-13 bg-[#efefef]",
                            children: bankItemBankName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "p-2 border-t border-[#ccc] font-normal text-13",
                            children: item.banka
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "p-2 border-t border-[#ccc] border-l border-r font-semibold text-13 bg-[#efefef]",
                            children: bankItemBankBranch
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "p-2 border-t border-[#ccc] font-normal text-13",
                            children: item.sube
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "p-2 border-t border-[#ccc] border-l border-r font-semibold text-13 bg-[#efefef]",
                            children: bankItemBankAccountName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "p-2 border-t border-[#ccc] font-normal text-13",
                            children: item.hesap_adi
                        })
                    ]
                }),
                item.iban_tl && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                            className: "p-2 border-t border-[#ccc] border-l border-r font-semibold text-13 bg-[#efefef]",
                            children: [
                                "\u20BA ",
                                bankItemBankIban
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "p-2 border-t border-[#ccc] font-normal text-13",
                            children: item.iban_tl
                        })
                    ]
                }),
                item.iban_dolar && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                            className: "p-2 border-t border-[#ccc] border-l border-r font-semibold text-13 bg-[#efefef]",
                            children: [
                                "$ ",
                                bankItemBankIban
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "p-2 border-t border-[#ccc] font-normal text-13",
                            children: item.iban_dolar
                        })
                    ]
                }),
                item.iban_euro && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                            className: "p-2 border-t border-[#ccc] border-l border-r font-semibold text-13 bg-[#efefef]",
                            children: [
                                "\u20AC ",
                                bankItemBankIban
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "p-2 border-t border-[#ccc] font-normal text-13",
                            children: item.iban_euro
                        })
                    ]
                }),
                item.iban_pound && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                            className: "p-2 border-t border-[#ccc] border-l border-r font-semibold text-13 bg-[#efefef]",
                            children: [
                                "\xa3 ",
                                bankItemBankIban
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "p-2 border-t border-[#ccc] font-normal text-13",
                            children: item.iban_pound
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Pages_BankaItem = (BankaItem);

// EXTERNAL MODULE: ./components/Fancybox.js
var Fancybox = __webpack_require__(92235);
;// CONCATENATED MODULE: ./components/Blank/Photos.js





var Photos = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 gap-4 mb-8",
        children: data.map(function(item, key) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fancybox["default"], {
                options: {
                    infinite: false
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rounded-md overflow-hidden relative h-24 ml:h-52",
                    "data-fancybox": "gallery",
                    "data-src": "https://cdn.balayivillasikirala.com.tr" + "/uploads/" + item.filename,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "cursor-pointer",
                        src: item.filename,
                        objectFit: "cover",
                        layout: "fill",
                        alt: "",
                        sizes: "(max-width: 768px) 60vw, (max-width: 1200px) 25vw, 25vw",
                        loader: LoaderRemote/* default */.Z
                    })
                })
            }, key);
        })
    });
};
/* harmony default export */ var Blank_Photos = (Photos);

// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/bi/BiCaretDown.js
var BiCaretDown = __webpack_require__(54706);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js + 1 modules
var disclosure = __webpack_require__(89855);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
;// CONCATENATED MODULE: ./components/Blank/Faq.js




var Faq = function(param) {
    var data = param.data;
    var CollapseItem = function(param) {
        var title = param.title, content = param.content;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
            children: function(param) {
                var close = param.close, open = param.open;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " border-solid border-2 rounded mb-2 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Button */.p.Button, {
                            className: "w-full text-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cursor-pointer flex items-center justify-between px-7 py-4 hover:bg-[#dedede] transition" + (open ? "bg-white " : "bg-[#f7f7f7] "),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold text-15 text-brand-black flex-1",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BiCaretDown/* BiCaretDown */.Q, {
                                        className: "text-orange transform transition-transform  " + (open ? "rotate-180" : ""),
                                        size: "25"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                            enter: "transition duration-100 ease-out",
                            enterFrom: "transform scale-95 opacity-0",
                            enterTo: "transform scale-100 opacity-100",
                            leave: "transition duration-75 ease-out",
                            leaveFrom: "transform scale-100 opacity-100",
                            leaveTo: "transform scale-95 opacity-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "opacity-50 text-sm text-brand-black px-7 pb-8 pt-4",
                                    dangerouslySetInnerHTML: {
                                        __html: content
                                    }
                                })
                            })
                        })
                    ]
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-8",
        children: data.map(function(item, key) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseItem, {
                title: item.baslik,
                content: item.icerik
            }, key);
        })
    });
};
/* harmony default export */ var Blank_Faq = (Faq);

;// CONCATENATED MODULE: ./components/FreeCancellationGuarantee/PaytheDoor.js



var PaytheDoor = function() {
    var ref = (0,TranslationContext/* useTranslation */.m)(), ptdTitle1 = ref.ptdTitle1, ptdTitle2 = ref.ptdTitle2, ptdTitle3 = ref.ptdTitle3, ptdP1 = ref.ptdP1, ptdP2 = ref.ptdP2, ptdP3 = ref.ptdP3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container lg:py-32 py-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex lg:flex-nowrap flex-wrap lg:items-start items-center lg:justify-start justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:w-1/2 w-full flex lg:items-start items-center lg:justify-start justify-center lg:mb-0 mb-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/kapi-odeme.png",
                        className: "object-contain w-[41.563rem] sm:h-[29.313rem] h-[12.5rem]"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:w-1/2 w-full flex lg:items-start items-center lg:justify-start justify-center lg:text-start text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-full sm:pl-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-wrap lg:flex-col lg:items-start items-center lg:justify-start justify-center mb-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: " text-primary font-bold sm:text-[2.875rem] text-[1.875rem]",
                                                children: ptdTitle1
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold text-dark sm:text-[2.875rem] text-[1.875rem] leading-[2.875rem]",
                                                children: ptdTitle2
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold text-dark sm:text-[2.875rem] text-[1.875rem] leading-[2.875rem]",
                                        children: ptdTitle3
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col fon-normal text-15 opacity-50",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Balayi Villası Kirala"
                                            }),
                                            " ",
                                            ptdP1
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: ptdP2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-4",
                                        children: ptdP3
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var FreeCancellationGuarantee_PaytheDoor = (PaytheDoor);

;// CONCATENATED MODULE: ./components/FreeCancellationGuarantee/Refund.js



var Refund = function() {
    var ref = (0,TranslationContext/* useTranslation */.m)(), refundTitle1 = ref.refundTitle1, refundTitle2 = ref.refundTitle2, refundP1Pre = ref.refundP1Pre, refundP1Strong = ref.refundP1Strong, refundP1Post = ref.refundP1Post, refundP2 = ref.refundP2, refundP3 = ref.refundP3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container lg:pb-36 pb-8 lg:mb-28 mb-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex lg:flex-nowrap flex-wrap lg:items-start items-center lg:justify-start justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:w-1/2 w-full flex lg:items-start items-center lg:justify-start justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/iade-image.png",
                        className: "object-contain w-[41.563rem] sm:h-[29.313rem] h-[12.5rem]"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:w-1/2 w-full flex flex-col lg:pl-12 lg:items-start items-center lg:justify-start justify-center lg:text-start text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col mb-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-dark sm:text-[2.875rem] text-25 font-bold leading-[2.25rem]",
                                    children: refundTitle1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-primary sm:text-[2.875rem] text-25 font-bold leading-[2.875rem]",
                                    children: refundTitle2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col fon-normal text-15 opacity-50",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        refundP1Pre,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: refundP1Strong
                                        }),
                                        " ",
                                        refundP1Post
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "Balayi Villası Kirala"
                                        }),
                                        " ",
                                        refundP2
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: refundP3.replace("{site}", "Balayi Villası Kirala")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var FreeCancellationGuarantee_Refund = (Refund);

;// CONCATENATED MODULE: ./components/FreeCancellationGuarantee/SecuraPayment.js



var SecuraPayment = function() {
    var ref = (0,TranslationContext/* useTranslation */.m)(), securaTitle1 = ref.securaTitle1, securaTitle2 = ref.securaTitle2, securaTitle3 = ref.securaTitle3, securaP1Pre = ref.securaP1Pre, securaP1Company = ref.securaP1Company, securaP1Post = ref.securaP1Post, securaP2 = ref.securaP2, securaP3 = ref.securaP3, securaPolicyTitle = ref.securaPolicyTitle, securaPolicyText = ref.securaPolicyText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-[#F0F6F8] lg:py-32 py-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex lg:flex-nowrap flex-wrap lg:items-start items-center lg:justify-start justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:w-1/2 w-full flex lg:order-1 order-2 lg:items-start items-center lg:justify-start justify-center lg:text-start text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col lg:items-end items-center lg:justify-end justify-center w-full lg:pr-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-wrap sm:justify-start justify-center sm:pl-12 mb-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-primary font-bold sm:text-[2.875rem] text-[1.875rem]",
                                            children: securaTitle1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex lg:flex-col lg:items-start items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-bold text-dark sm:text-[2.875rem] text-[1.875rem]",
                                                    children: securaTitle2
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-bold text-dark sm:text-[2.875rem] text-[1.875rem] leading-[2.875rem]",
                                                    children: securaTitle3
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col fon-normal text-15 opacity-50 lg:text-end text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        "Balayi Villası Kirala",
                                                        " (",
                                                        "https://www.balayivillasikirala.com.tr",
                                                        " )"
                                                    ]
                                                }),
                                                securaP1Pre,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: securaP1Company
                                                }),
                                                " ",
                                                securaP1Post
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: securaP2
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: securaP3
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: securaPolicyTitle
                                                }),
                                                " ",
                                                securaPolicyText.split("{domain}").join("https://www.balayivillasikirala.com.tr")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:w-1/2 w-full flex lg:items-start items-center lg:justify-start justify-center lg:order-2 order-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/secure-payment.png",
                            className: "object-contain w-[41.563rem] sm:h-[29.313rem] h-[12.5rem]"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var FreeCancellationGuarantee_SecuraPayment = (SecuraPayment);

;// CONCATENATED MODULE: ./components/FreeCancellationGuarantee/Unconditionalmoney.js




var Unconditionalmoney = function() {
    var ref = (0,TranslationContext/* useTranslation */.m)(), UnconditionalmoneyTitle = ref.UnconditionalmoneyTitle, UnconditionalmoneySubTitle = ref.UnconditionalmoneySubTitle, UnconditionalmoneyDescription = ref.UnconditionalmoneyDescription, UnconditionalmoneyDescription2 = ref.UnconditionalmoneyDescription2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "guest-protection-gradiend lg:mb-44 mb-16 overflow-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "guest-adam-image relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container flex lg:items-start items-center lg:justify-start justify-center absolute top-1/2 lg:w-full left-0 -translate-y-1/2 xl:ml-[9.281rem]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex sm:flex-nowrap flex-wrap sm:items-start items-center sm:justify-start justify-center sm:text-start text-center bg-white xl:w-1/2 md:w-3/4 w-full xl:py-16 sm:py-10 py-4 xl:pr-36 sm:pr-16 pr-4 sm:pl-11 pl-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex mr-6 flex-shrink-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "object-contain w-24 h-24 relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "",
                                    src: "/images/guest-protection-image.jpeg",
                                    layout: "fill"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col sm:mb-12 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-text-securePayment sm:text-[2rem] text-25 font-bold leading-[2.4rem]",
                                            children: UnconditionalmoneyTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-dark sm:text-[2rem] text-25 font-bold leading-[2.4rem]",
                                            children: UnconditionalmoneySubTitle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-normal text-13 opacity-50 tracking-[0.031rem] pb-4",
                                            children: UnconditionalmoneyDescription
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "font-normal text-13 opacity-50 tracking-[0.031rem] text-text-securePayment2 border-b-2 border-text-securePayment2 pb-8",
                                            children: [
                                                "(",
                                                UnconditionalmoneyDescription2,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var FreeCancellationGuarantee_Unconditionalmoney = (Unconditionalmoney);

// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
// EXTERNAL MODULE: ./components/ImageLoader.js
var ImageLoader = __webpack_require__(71700);
// EXTERNAL MODULE: ./components/Pages/PaymentCustomer/PaymentItem.js
var PaymentItem = __webpack_require__(1777);
// EXTERNAL MODULE: ./components/Pages/PaymentCustomer/PaymentTextarea.js
var PaymentTextarea = __webpack_require__(22724);
// EXTERNAL MODULE: ./components/Pages/SinglePaymentPage.js + 3 modules
var SinglePaymentPage = __webpack_require__(70618);
;// CONCATENATED MODULE: ./components/Pages/Installment.js









var Installment = function() {
    var ref = (0,TranslationContext/* useTranslation */.m)(), installPre = ref.installPre, installMid = ref.installMid, installNote = ref.installNote, installUpTo = ref.installUpTo, installTursab = ref.installTursab;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex lg:flex-nowrap flex-wrap items-center justify-center my-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:w-1/2 w-full flex lg:items-start items-center lg:justify-start justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " w-[41.563rem] sm:h-[400px] h-[12.5rem] relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/iade-image.png",
                                objectFit: "contain",
                                layout: "fill",
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col mb-8 lg:w-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-8 flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-[20px] font-bold",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-primary",
                                                children: installPre
                                            }),
                                            " ",
                                            installMid.replace("{site}", "Balayi Villası Kirala")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[14px] font-medium text-black",
                                        children: installNote
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-center items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative w-[400px] h-[20px] mb-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/payments.svg",
                                                objectFit: "contain",
                                                layout: "fill",
                                                alt: "",
                                                loader: ImageLoader/* default */.Z
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-15 font-bold text-primary mb-3",
                                        children: installUpTo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[14px] font-extrabold text-black text-center",
                                        children: installTursab.replace("{site}", "Balayi Villası Kirala")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Pages_Installment = (Installment);

;// CONCATENATED MODULE: ./components/Pages/StaticPage.js








var StaticPage = function(param) {
    var ssr = param.ssr;
    if (ssr.RoutingTypeId == "Installment") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pages_Installment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeCancellationGuarantee_Unconditionalmoney, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeCancellationGuarantee_Refund, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeCancellationGuarantee_SecuraPayment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeCancellationGuarantee_PaytheDoor, {})
        ]
    });
};
/* harmony default export */ var Pages_StaticPage = (StaticPage);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 16 modules
var dialog = __webpack_require__(39627);
;// CONCATENATED MODULE: ./components/Pages/GetOffer/FormModals.js




var FormModals = function(param) {
    var show = param.show, setShow = param.setShow, onModalClose = param.onModalClose;
    var ref = (0,TranslationContext/* useTranslation */.m)(), getOfferModalTitle = ref.getOfferModalTitle, getOfferModalCaption = ref.getOfferModalCaption, getOfferModalDescription = ref.getOfferModalDescription, close = ref.close;
    var cancelButtonRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: show,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-50",
            initialFocus: cancelButtonRef,
            onClose: function() {
                setShow(false);
                onModalClose();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-black bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sm:flex sm:items-start",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-3 sm:mt-0 sm:ml-4 ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex justify-center w-full mb-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-black font-normal text-center",
                                                            children: getOfferModalTitle
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col ",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-[20px] font-extrabold text-black mb-3 leading-7",
                                                                children: getOfferModalCaption
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-15 font-normal text-black",
                                                                children: getOfferModalDescription
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "mt-3 inline-flex w-full focus:hidden justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm",
                                            onClick: function() {
                                                setShow(false);
                                                onModalClose();
                                            },
                                            ref: cancelButtonRef,
                                            children: close
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var GetOffer_FormModals = (FormModals);

;// CONCATENATED MODULE: ./components/Pages/GetOffer/FormBtn.js




var FormBtn = function(param) {
    var disabled = param.disabled, handleSubmit = param.handleSubmit, onModalClose = param.onModalClose;
    var getOfferSendBtn = (0,TranslationContext/* useTranslation */.m)().getOfferSendBtn;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: " py-3 md:py-[18px] md:px-[52px] text-white px-7 bg-brand-color-primary disabled:opacity-75 disabled:cursor-not-allowed",
                onClick: function() {
                    handleSubmit(setShow);
                },
                disabled: !disabled,
                children: getOfferSendBtn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOffer_FormModals, {
                onModalClose: onModalClose,
                show: show,
                setShow: setShow
            })
        ]
    });
};
/* harmony default export */ var GetOffer_FormBtn = (FormBtn);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components/Pages/GetOffer/PersonCount.js

var PersonCount = function(param) {
    var name = param.name, person = param.person, setPerson = param.setPerson, placeholder = param.placeholder;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-0 mb-6 w-full group",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "number",
                name: name,
                id: name,
                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                placeholder: " ",
                value: person,
                onChange: function(e) {
                    return setPerson(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: name,
                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                children: placeholder
            })
        ]
    });
};
/* harmony default export */ var GetOffer_PersonCount = (PersonCount);

;// CONCATENATED MODULE: ./components/Pages/GetOffer/Pagefive.js






var Pagefive = function(param) {
    var formdata = param.formdata, setformdata = param.setformdata, validSteps = param.validSteps, setvalidSteps = param.setvalidSteps;
    var ref = (0,react.useState)(formdata.name), name = ref[0], setName = ref[1];
    var ref1 = (0,react.useState)(formdata.email), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react.useState)(formdata.phone), phone = ref2[0], setPhone = ref2[1];
    var ref3 = (0,react.useState)(formdata.adult), adult = ref3[0], setAdult = ref3[1];
    var ref4 = (0,react.useState)(formdata.child), child = ref4[0], setChild = ref4[1];
    var ref5 = (0,react.useState)(formdata.infant), infant = ref5[0], setInfant = ref5[1];
    (0,react.useEffect)(function() {
        var isValid = name && email && phone && Number(adult) > 0;
        setvalidSteps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, validSteps), {
            5: isValid
        }));
        setformdata((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formdata), {
            name: name,
            email: email,
            phone: phone,
            adult: adult,
            child: child,
            infant: infant
        }));
    }, [
        name,
        email,
        phone,
        adult,
        child,
        infant
    ]);
    var ref6 = (0,TranslationContext/* useTranslation */.m)(), getOfferStep5Title = ref6.getOfferStep5Title, getOfferFormFullName = ref6.getOfferFormFullName, getOfferFormEmail = ref6.getOfferFormEmail, getOfferFormPhone = ref6.getOfferFormPhone, getOfferFormAdult = ref6.getOfferFormAdult, getOfferFormChild = ref6.getOfferFormChild, getOfferFormInfant = ref6.getOfferFormInfant;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "md:text-25 text-15 text-black font-medium",
                    children: getOfferStep5Title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid sm:grid-cols-2 grid-cols-1 sm:gap-5 gap-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-6 w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                name: "name",
                                id: "name",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                value: name,
                                onChange: function(e) {
                                    return setName(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "name",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: getOfferFormFullName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-6 w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "mail",
                                name: "email",
                                id: "email",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                required: "",
                                value: email,
                                onChange: function(e) {
                                    return setEmail(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "email",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: getOfferFormEmail
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-6 w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "number",
                                name: "phone",
                                id: "phone",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                required: "",
                                value: phone,
                                onChange: function(e) {
                                    return setPhone(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "phone",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-reervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: getOfferFormPhone
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOffer_PersonCount, {
                        name: "adult",
                        person: adult,
                        setPerson: setAdult,
                        placeholder: getOfferFormAdult
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOffer_PersonCount, {
                        name: "child",
                        person: child,
                        setPerson: setChild,
                        placeholder: getOfferFormChild
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOffer_PersonCount, {
                        name: "infant",
                        person: infant,
                        setPerson: setInfant,
                        placeholder: getOfferFormInfant
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var GetOffer_Pagefive = (Pagefive);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./components/Pages/GetOffer/Pagefour.js








var Pagefour = function(param) {
    var formdata = param.formdata, setformdata = param.setformdata, validSteps = param.validSteps, setvalidSteps = param.setvalidSteps, data = param.data;
    var ref = (0,react.useState)(formdata.Categories), checked = ref[0], setChecked = ref[1];
    var handleChange = function(e) {
        if (e.target.checked) {
            setChecked((0,_to_consumable_array/* default */.Z)(checked).concat([
                e.target.value
            ]));
        } else {
            var old = (0,_to_consumable_array/* default */.Z)(checked);
            var index = old.findIndex(function(a) {
                return a == e.target.value;
            });
            old.splice(index, 1);
            setChecked(old);
        }
    };
    (0,react.useEffect)(function() {
        setformdata((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formdata), {
            Categories: checked
        }));
        setvalidSteps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, validSteps), {
            4: checked.length > 0
        }));
    }, [
        checked
    ]);
    var getOfferStep4Title = (0,TranslationContext/* useTranslation */.m)().getOfferStep4Title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col mb-7",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "md:text-25 text-15 text-black font-medium",
                    children: getOfferStep4Title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid sm:grid-cols-2 grid-cols-1 gap-6",
                children: data.Categories.filter(function(e) {
                    return e[formdata.categoryType == "1" ? "ozelGun" : "aile"] == "1";
                }).map(function(e) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "w-full font-normal text-[14px] flex items-center justify-between cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[60px] h-[60px] rounded-full mr-2 relative p-1",
                                        children: e.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: e.icon,
                                            width: 60,
                                            height: 60,
                                            className: "object-contain",
                                            alt: e.baslik,
                                            loader: LoaderRemote/* default */.Z
                                        })
                                    }),
                                    e.baslik
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                value: e.id,
                                name: "Categories",
                                className: "w-8 h-8",
                                onChange: handleChange,
                                checked: checked.includes(e.id)
                            })
                        ]
                    }, e.id);
                })
            })
        ]
    });
};
/* harmony default export */ var GetOffer_Pagefour = (Pagefour);

// EXTERNAL MODULE: ./node_modules/react-date-range/dist/index.js
var dist = __webpack_require__(30286);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/styles.css
var styles = __webpack_require__(71541);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/theme/default.css
var theme_default = __webpack_require__(32049);
// EXTERNAL MODULE: ./helper/useLocale.js
var useLocale = __webpack_require__(92072);
;// CONCATENATED MODULE: ./components/Pages/GetOffer/PageOne.js







 // main css file
 // theme css file



var PageOne = function(param) {
    var formdata = param.formdata, setformdata = param.setformdata, validSteps = param.validSteps, setvalidSteps = param.setvalidSteps;
    var ToggleShow = function ToggleShow() {
        setIsShow(!isShow);
    };
    var CloseToggle = function CloseToggle() {
        setIsShow(false);
    };
    var onChange = function onChange(item) {
        setState2([
            item.selection
        ]);
        if (item.selection.startDate !== item.selection.endDate) {
            CloseToggle();
        }
    };
    var localeData = (0,useLocale/* default */.Z)();
    var ref = (0,react.useState)(false), isShow = ref[0], setIsShow = ref[1];
    var ref1 = (0,react.useState)([
        {
            startDate: formdata.startDate ? formdata.startDate : new Date(),
            endDate: formdata.endDate ? formdata.endDate : new Date(),
            key: "selection",
            isShow: 0
        }, 
    ]), state2 = ref1[0], setState2 = ref1[1];
    (0,react.useEffect)(function() {
        if (state2[0].startDate.toString() !== state2[0].endDate.toString()) {
            setvalidSteps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, validSteps), {
                1: true
            }));
            setformdata((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formdata), {
                startDate: state2[0].startDate,
                endDate: state2[0].endDate
            }));
        } else {
            setvalidSteps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, validSteps), {
                1: false
            }));
            setformdata((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formdata), {
                startDate: null,
                endDate: null
            }));
        }
    }, [
        state2
    ]);
    var ref2 = (0,TranslationContext/* useTranslation */.m)(), getOfferStep1Title1 = ref2.getOfferStep1Title1, getOfferStep1Title2 = ref2.getOfferStep1Title2, getOfferStep1Caption1 = ref2.getOfferStep1Caption1, getOfferStep1Caption2 = ref2.getOfferStep1Caption2, getOfferStep1SubTitle = ref2.getOfferStep1SubTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-start mb-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-black text-2xl mm:text-3xl ml:text-[35px] font-medium leading-[20px]",
                            children: getOfferStep1Title1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[#ed7824] text-[35px] font-medium",
                            children: getOfferStep1Title2
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col lg:mb-[62px] mb-7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "md:text-[31px] sm:text-25 text-[18px] text-black font-bold mb-2 leading-8 mb-2",
                            children: [
                                getOfferStep1Caption1,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "md:text-[31px] sm:text-25 text-[18px] font-bold text-[#E66E07] ml-1",
                                    children: getOfferStep1Caption2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "md:text-[21px] text-15 text-black font-medium leading-7 md:mb-1",
                            children: getOfferStep1SubTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sm:text-[15px] text-13 text-black font-normal leading-5"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inline-flex flex-wrap relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "border border-[#E5E7ED] md:px-[62px] sm:px-9 px-4 md:py-[25px] py-4 flex items-center cursor-pointer",
                            onClick: function() {
                                return ToggleShow();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "xl:text-[15px] text-13 text-black font-normal ",
                                    children: (0,format["default"])(state2[0].startDate, "dd MMMM Y", {
                                        locale: localeData
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[38px] h-[29px] md:mx-[73px] sm:mx-7 mx-4 relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/icons/date.svg",
                                        layout: "fill",
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "xl:text-[15px] text-13 text-black font-normal ",
                                    children: (0,format["default"])(state2[0].endDate, "dd MMMM Y", {
                                        locale: localeData
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-full " + (isShow ? "inline-block z-50" : "hidden"),
                            children: localeData && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* DateRange */.C0, {
                                editableDateInputs: false,
                                onChange: function(item) {
                                    return onChange(item);
                                },
                                moveRangeOnFirstSelection: false,
                                ranges: state2,
                                showDateDisplay: false,
                                locale: localeData,
                                months: 1,
                                minDate: new Date(),
                                showMonthAndYearPickers: false,
                                direction: "horizontal",
                                className: "availability-calendar"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GetOffer_PageOne = (PageOne);

;// CONCATENATED MODULE: ./components/Pages/GetOffer/Pagethree.js





var Pagethree = function(param) {
    var formdata = param.formdata, setformdata = param.setformdata, validSteps = param.validSteps, setvalidSteps = param.setvalidSteps;
    var ref = (0,TranslationContext/* useTranslation */.m)(), getOfferStep3Title = ref.getOfferStep3Title, getOfferStep3Option1 = ref.getOfferStep3Option1, getOfferStep3Option2 = ref.getOfferStep3Option2;
    var ref1 = (0,react.useState)(formdata.categoryType), categoryType = ref1[0], setcategoryType = ref1[1];
    (0,react.useEffect)(function() {
        setformdata((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formdata), {
            categoryType: categoryType,
            Categories: []
        }));
        setvalidSteps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, validSteps), {
            3: categoryType > 0
        }));
    }, [
        categoryType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col mb-7",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "md:text-25 text-15 text-black font-medium",
                    children: getOfferStep3Title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid sm:grid-cols-2 grid-cols-1 gap-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "w-full font-bold sm:text-[18px] text-15 h-16 px-5 bg-[#f5f5f5] flex items-center justify-between cursor-pointer",
                        children: [
                            getOfferStep3Option1,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "radio",
                                value: "1",
                                name: "topping",
                                className: "w-8 h-8",
                                onChange: function() {
                                    return setcategoryType(1);
                                },
                                checked: categoryType == 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "w-full font-bold sm:text-[18px] text-15 h-16 px-5 bg-[#f5f5f5] flex items-center justify-between cursor-pointer",
                        children: [
                            getOfferStep3Option2,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "radio",
                                name: "topping",
                                value: "2",
                                className: "w-8 h-8",
                                onChange: function() {
                                    return setcategoryType(2);
                                },
                                checked: categoryType == 2
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var GetOffer_Pagethree = (Pagethree);

;// CONCATENATED MODULE: ./components/Pages/GetOffer/PageTwo.js





var PageTwo = function(param) {
    var formdata = param.formdata, setformdata = param.setformdata, validSteps = param.validSteps, setvalidSteps = param.setvalidSteps;
    var ref = (0,TranslationContext/* useTranslation */.m)(), getOfferStep2Title = ref.getOfferStep2Title, getOfferStep2Option1 = ref.getOfferStep2Option1, getOfferStep2Option2 = ref.getOfferStep2Option2, getOfferStep2Option3 = ref.getOfferStep2Option3;
    var ref1 = (0,react.useState)(formdata.priceType), priceType = ref1[0], setPriceType = ref1[1];
    (0,react.useEffect)(function() {
        setformdata((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formdata), {
            priceType: priceType
        }));
        setvalidSteps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, validSteps), {
            2: priceType > 0
        }));
    }, [
        priceType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col mb-7",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "md:text-25 text-15 text-black font-medium",
                    children: getOfferStep2Title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid sm:grid-cols-3 ml:grid-cols-2 grid-cols-1 gap-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "w-full font-bold sm:text-[18px] text-15 h-16 px-5 bg-[#f5f5f5] flex items-center justify-between cursor-pointer",
                        children: [
                            getOfferStep2Option1,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "radio",
                                value: "1",
                                className: "w-8 h-8",
                                onChange: function() {
                                    return setPriceType(1);
                                },
                                checked: priceType == 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "w-full font-bold sm:text-[18px] text-15 h-16 px-5 bg-[#f5f5f5] flex items-center justify-between cursor-pointer",
                        children: [
                            getOfferStep2Option2,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "radio",
                                value: "2",
                                className: "w-8 h-8",
                                onChange: function() {
                                    return setPriceType(2);
                                },
                                checked: priceType == 2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "w-full font-bold sm:text-[18px] text-15 h-16 px-5 bg-[#f5f5f5] flex items-center justify-between cursor-pointer",
                        children: [
                            getOfferStep2Option3,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "radio",
                                value: "3",
                                className: "w-8 h-8",
                                onChange: function() {
                                    return setPriceType(3);
                                },
                                checked: priceType == 3
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var GetOffer_PageTwo = (PageTwo);

// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./components/BackButton.js
var BackButton = __webpack_require__(70454);
;// CONCATENATED MODULE: ./components/Pages/GetOffer.js

















var GetOffer = function(param) {
    var ssr = param.ssr, isAppWebView = param.isAppWebView;
    var ref = (0,TranslationContext/* useTranslation */.m)(), getOfferNextBtn = ref.getOfferNextBtn, getOfferPrevBtn = ref.getOfferPrevBtn, getOfferFormError = ref.getOfferFormError;
    var localeData = (0,useLocale/* default */.Z)();
    var ref1 = (0,react.useState)({
        startDate: null,
        endDate: null,
        priceType: 0,
        categoryType: 0,
        Categories: [],
        name: "",
        email: "",
        phone: "",
        adult: 0,
        child: 0,
        infant: 0
    }), formdata = ref1[0], setformdata = ref1[1];
    var ref2 = (0,react.useState)({
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
    }), validSteps = ref2[0], setvalidSteps = ref2[1];
    var ref3 = (0,react.useState)(1), currentPage = ref3[0], setCurrentPage = ref3[1];
    var maxPageLimit = 5;
    var minPageLimit = 1;
    var onPrevClick = function() {
        if (currentPage - 1 <= minPageLimit) setCurrentPage(minPageLimit);
        else setCurrentPage(currentPage - 1);
    };
    var onNextClick = function() {
        if (currentPage + 1 >= maxPageLimit) setCurrentPage(maxPageLimit);
        else setCurrentPage(currentPage + 1);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(setShow) {
            var a, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        a = (0,_object_spread/* default */.Z)({}, formdata);
                        a.startDate = (0,format["default"])(a.startDate, "yyyy-MM-dd", {
                            locale: localeData
                        });
                        a.endDate = (0,format["default"])(a.endDate, "yyyy-MM-dd", {
                            locale: localeData
                        });
                        _ctx.next = 5;
                        return (0,api/* SendOffer */.xS)(a);
                    case 5:
                        response = _ctx.sent;
                        if (response.data.result) {
                            setShow(true);
                        } else react_toastify_esm/* toast.error */.Am.error(getOfferFormError);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(setShow) {
            return _ref.apply(this, arguments);
        };
    }();
    var onModalClose = function() {
        setvalidSteps({
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0
        });
        setformdata({
            startDate: null,
            endDate: null,
            priceType: 0,
            categoryType: 0,
            Categories: [],
            name: "",
            email: "",
            phone: "",
            adult: 0,
            child: 0,
            infant: 0
        });
        setCurrentPage(1);
    };
    // const getOfferBgMap = {
    //   1: formdata.startDate && formdata.endDate,
    //   2: formdata.priceType > 0,
    //   3: formdata.categoryType > 0
    //   3: formdata.Categories.length > 0,
    //   4: formdata.name && formdata.email && formdata.phone && formdata.person > 0,
    //   5: true,
    // };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex lg:flex-nowrap flex-wrap lg:h-[calc(100vh-96px)] sm:min-h-[800px] relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:w-1/2 w-full sm:block hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-getOffer sm:bg-get-offer bg-get-offer-pst bg lg:bg-[-252px]-bottom bg-contain bg-no-repeat lg:h-full sm:h-[400px] h-[190px]"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                    isAppWebView: isAppWebView,
                    top: "top-0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:w-1/2 w-full xl:px-[80px] px-5 flex flex-col pt-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center lg:justify-end lg:mb-[50px] mb-8 lg:pt-[20px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "md:text-[31px] text-25 font-light text-black",
                                children: [
                                    currentPage,
                                    "/",
                                    maxPageLimit
                                ]
                            })
                        }),
                        currentPage == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOffer_PageOne, {
                            formdata: formdata,
                            setformdata: setformdata,
                            validSteps: validSteps,
                            setvalidSteps: setvalidSteps
                        }),
                        currentPage == 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOffer_PageTwo, {
                            formdata: formdata,
                            setformdata: setformdata,
                            validSteps: validSteps,
                            setvalidSteps: setvalidSteps
                        }),
                        currentPage == 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOffer_Pagethree, {
                            formdata: formdata,
                            setformdata: setformdata,
                            validSteps: validSteps,
                            setvalidSteps: setvalidSteps
                        }),
                        currentPage == 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOffer_Pagefour, {
                                formdata: formdata,
                                setformdata: setformdata,
                                validSteps: validSteps,
                                setvalidSteps: setvalidSteps,
                                data: ssr.result
                            })
                        }),
                        currentPage == 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOffer_Pagefive, {
                            formdata: formdata,
                            setformdata: setformdata,
                            validSteps: validSteps,
                            setvalidSteps: setvalidSteps
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-center lg:justify-end gap-x-[15px] mt-auto mb-16",
                            children: [
                                currentPage > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "bg-getOffer3 md:py-[18px] py-3 md:px-[52px] px-7",
                                    onClick: onPrevClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-white text-[16px] font-medium",
                                        children: getOfferPrevBtn
                                    })
                                }),
                                currentPage !== maxPageLimit && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "".concat(!validSteps[currentPage] ? "bg-getOffer2" : "bg-getOffer3", " text-[16px] text-white font-medium md:py-[18px] py-3 md:px-[52px] px-7 disabled:cursor-not-allowed"),
                                    onClick: onNextClick,
                                    disabled: !validSteps[currentPage],
                                    children: getOfferNextBtn
                                }),
                                currentPage === maxPageLimit && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOffer_FormBtn, {
                                    disabled: Object.values(validSteps).every(function(e) {
                                        return e == true;
                                    }),
                                    handleSubmit: handleSubmit,
                                    onModalClose: onModalClose
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Pages_GetOffer = (GetOffer);

;// CONCATENATED MODULE: ./components/Pages/Advertise/InfoItem.js



var InfoItem = function(param) {
    var title = param.title, content = param.content, IconName = param.IconName, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: " items-center py-5 flex border-b first:pt-0 last:pb-0 border-0 last:border-0 sm:last:border-b lg:last:border-0 sm:flex-row flex-col sm:text-start text-center ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "shrink-0 w-12 h-12 flex items-center justify-center sm:mb-0 mb-3 rounded-full text-center text-white " + className,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                    name: IconName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col sm:ml-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "font-bold lg:text-base text-sm text-[#333738]",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-medium sm:text-sm text-xs leading-4 text-[#A2B2B8]",
                        children: content
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Advertise_InfoItem = (InfoItem);

;// CONCATENATED MODULE: ./components/Pages/Advertise/Info.js




var Info = function() {
    var ref = (0,TranslationContext/* useTranslation */.m)(), advInfo1Title = ref.advInfo1Title, advInfo1Text = ref.advInfo1Text, advInfo2Title = ref.advInfo2Title, advInfo2Text = ref.advInfo2Text, advInfo3Title = ref.advInfo3Title, advInfo3Text = ref.advInfo3Text, advInfo4Title = ref.advInfo4Title, advInfo4Text = ref.advInfo4Text, advInfo5Title = ref.advInfo5Title, advInfo5Text = ref.advInfo5Text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "grid gap-5 p-3 py-6 bg-white border rounded-md shadow-xl xl:p-8 lg:p-5 sm:grid-cols-2 lg:grid-cols-1 lg:gap-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Advertise_InfoItem, {
                className: "bg-indigo-500",
                IconName: "Wallet",
                title: advInfo1Title,
                content: advInfo1Text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Advertise_InfoItem, {
                className: "bg-green-600",
                IconName: "Share",
                title: advInfo2Title,
                content: advInfo2Text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Advertise_InfoItem, {
                className: "bg-primary",
                IconName: "Comment",
                title: advInfo3Title,
                content: advInfo3Text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Advertise_InfoItem, {
                className: "bg-orange",
                IconName: "Camera",
                title: advInfo4Title,
                content: advInfo4Text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Advertise_InfoItem, {
                className: "bg-red-700",
                IconName: "Team",
                title: advInfo5Title,
                content: advInfo5Text
            })
        ]
    });
};
/* harmony default export */ var Advertise_Info = (Info);

;// CONCATENATED MODULE: ./components/Pages/Advertise/Left.js



var left = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lg:w-4/12 w-full lg:mr-3 lg:mb-0 mb-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Advertise_Info, {})
    });
};
/* harmony default export */ var Left = (left);

;// CONCATENATED MODULE: ./components/Pages/Advertise/FormInfoItem.js


var FormInfoItem = function(param) {
    var PlaceHolder = param.PlaceHolder, id = param.id;
    var ref = useState(""), value = ref[0], setValue = ref[1];
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ _jsx("input", {
                id: id,
                className: "block rounded-md md:py-5 py-3 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                placeholder: " ",
                onChange: function(e) {
                    return setValue(e.target.value);
                },
                value: value
            }),
            /*#__PURE__*/ _jsx("label", {
                htmlFor: id,
                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                children: PlaceHolder
            })
        ]
    });
};
/* harmony default export */ var Advertise_FormInfoItem = ((/* unused pure expression or super */ null && (FormInfoItem)));

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./components/Pages/Payment/Input.js
var Input = __webpack_require__(16719);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/yup-locales/dist/yup-locales.esm.js
var yup_locales_esm = __webpack_require__(18700);
;// CONCATENATED MODULE: ./validations/AddVillaRequestSheme.js


if (true) es/* setLocale */.i_(yup_locales_esm.tr); // en: Yup varsayilan (Ingilizce) mesajlari
var AddVillaRequestSheme = es/* object */.Ry().shape({
    name: es/* string */.Z_().required(),
    surname: es/* string */.Z_().required(),
    phoneNumberIsValid: es/* boolean */.O7().isTrue(),
    email: es/* string */.Z_().required().email(),
    destination: es/* string */.Z_().required(),
    roomCount: es/* string */.Z_().required(),
    poolType: es/* array */.IX().min(1).required(),
    seaView: es/* string */.Z_().required(),
    message: es/* string */.Z_()
});

// EXTERNAL MODULE: ./components/Reservation/PhoneInput.js
var PhoneInput = __webpack_require__(23515);
;// CONCATENATED MODULE: ./components/Pages/Advertise/Right.js











var Right = function() {
    var ref = (0,TranslationContext/* useTranslation */.m)(), name = ref.name, surname = ref.surname, email = ref.email, phone = ref.phone, sendBtnText = ref.sendBtnText, addVillaDestination = ref.addVillaDestination, roomCount = ref.roomCount, poolType = ref.poolType, advertiseQPre = ref.advertiseQPre, advertiseQStrong = ref.advertiseQStrong, advertiseQPost = ref.advertiseQPost, advertiseFormReceived = ref.advertiseFormReceived, poolPrivate = ref.poolPrivate, poolShared = ref.poolShared, poolNone = ref.poolNone, seaViewLabel = ref.seaViewLabel, yesLabel = ref.yesLabel, noLabel = ref.noLabel, yourMessagePlaceholder = ref.yourMessagePlaceholder, successTitle = ref.successTitle, closeBtn = ref.closeBtn;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(advertiseFormReceived), message = ref2[0], setMessage = ref2[1];
    var poolTypes = [
        // value: sunucuya giden (Turkce kalir, personel okur); text: ekranda gorunen
        {
            id: 1,
            value: "\xd6zel Havuz",
            text: poolPrivate
        },
        {
            id: 2,
            value: "Ortak Havuz",
            text: poolShared
        },
        {
            id: 3,
            value: "Havuz Yok",
            text: poolNone
        }, 
    ];
    var HandleSubmit = function(values, actions) {
        (0,api/* SendAddVillaForm */.F6)(values).then(function(e) {
            if (e.data.success) {
                setMessage(e.data.success);
                setIsOpen(true);
            } else {
                react_toastify_esm/* toast.error */.Am.error(e.data.error);
            }
        }).catch(function(e) {
            react_toastify_esm/* toast.error */.Am.error(e.message);
        }).finally(function() {
            actions.setSubmitting(false);
            actions.resetForm();
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative order-first w-full mt-3 lg:w-8/12 lg:ml-3 lg:mt-0 lg:order-last",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-5 bg-white border rounded-md shadow-xl lg:p-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-2xl text-brand-black text-light sm:text-3xl",
                        children: [
                            advertiseQPre,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: " text-brand-blue",
                                children: advertiseQStrong
                            }),
                            advertiseQPost
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        initialValues: {
                            name: "",
                            surname: "",
                            phoneNumber: "",
                            phoneNumberIsValid: false,
                            email: "",
                            destination: "",
                            roomCount: "",
                            poolType: [],
                            seaView: "",
                            message: ""
                        },
                        validationSchema: AddVillaRequestSheme,
                        onSubmit: HandleSubmit,
                        children: function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                onSubmit: props.handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid gap-6 mt-5 mb-6 md:grid-cols-2 lg:mt-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative z-0 w-full p-1 group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    name: "name",
                                                    placeholder: " ",
                                                    label: name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative z-0 w-full p-1 group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    name: "surname",
                                                    placeholder: " ",
                                                    label: surname
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative z-0 w-full group min-h-[70px] p-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput/* default */.Z, {
                                                    name: "phoneNumber",
                                                    validname: "phoneNumberIsValid",
                                                    label: phone,
                                                    mode: "simple",
                                                    isrequired: "required"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative z-0 w-full p-1 group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    name: "email",
                                                    placeholder: " ",
                                                    label: email
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative z-0 w-full p-1 group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    name: "destination",
                                                    placeholder: " ",
                                                    label: addVillaDestination
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative z-0 w-full p-1 group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    name: "roomCount",
                                                    placeholder: " ",
                                                    label: roomCount
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "p-4 mb-6 border rounded-md ".concat(props.errors.poolType && props.touched.poolType ? "border-red-500" : ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block mb-2 text-sm font-bold text-[#333738]",
                                                children: poolType
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-wrap items-center mt-3",
                                                children: poolTypes.map(function(item) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxItem, {
                                                        id: item.id,
                                                        text: item.text,
                                                        value: item.value
                                                    }, item.id);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "p-4 mb-6 border rounded-md ".concat(props.errors.seaView && props.touched.seaView ? "border-red-500" : ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block mb-2 text-sm font-bold text-[#333738]",
                                                children: seaViewLabel
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center mt-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center mr-6 cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                type: "radio",
                                                                name: "seaView",
                                                                value: "Var",
                                                                className: "w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 ",
                                                                id: "seaView_1"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "seaView_1",
                                                                className: "ml-2 text-xs font-light text-[#333738]",
                                                                children: yesLabel
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center mr-6 cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                type: "radio",
                                                                name: "seaView",
                                                                value: "Yok",
                                                                className: "w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 ",
                                                                id: "seaView_0"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "seaView_0",
                                                                className: "ml-2 text-xs font-light text-[#333738]",
                                                                children: noLabel
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                            component: "textarea",
                                            name: "message",
                                            rows: "4",
                                            className: "block p-2.5 w-full text-sm text-[#333738] rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500",
                                            placeholder: yourMessagePlaceholder
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-end w-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "submit",
                                            disabled: props.isSubmitting,
                                            className: "text-white bg-brand-color-primary hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center disabled:opacity-60 disabled:cursor-not-allowed",
                                            children: sendBtnText
                                        })
                                    })
                                ]
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.V, {
                open: isOpen,
                onClose: function() {
                    return setIsOpen(false);
                },
                transition: true,
                className: "fixed z-50 inset-0 flex w-screen items-center justify-center bg-black/30 rounded-md p-4 transition duration-300 ease-out data-[closed]:opacity-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                    className: "max-w-lg p-8 space-y-4 bg-white rounded-md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Title */.V.Title, {
                            className: "font-bold",
                            children: successTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: message
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex gap-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "p-2 text-sm text-white bg-red-400 rounded-md",
                                onClick: function() {
                                    return setIsOpen(false);
                                },
                                children: closeBtn
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Advertise_Right = (Right);
var CheckBoxItem = function(param) {
    var text = param.text, id = param.id, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center w-1/2 mb-4 mr-0 md:mr-6 md:mb-0 last:mr-0 md:w-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                type: "checkbox",
                name: "poolType",
                value: value,
                className: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500",
                id: "poolType_checkbox_".concat(id)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "poolType_checkbox_".concat(id),
                className: "ml-2 text-xs font-light text-[#333738]",
                children: text
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Pages/Advertise.js






var Advertise = function(param) {
    var ssr = param.ssr, isAppWebView = param.isAppWebView;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
                title: ssr.result.baslik
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex lg:flex-row flex-col my-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                            isAppWebView: isAppWebView,
                            top: "-top-12",
                            left: "left-0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Left, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Advertise_Right, {
                            isAppWebView: isAppWebView
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Pages_Advertise = (Advertise);

;// CONCATENATED MODULE: ./components/Index/ReviewItem.js





var ReviewItem = function(param) {
    var data = param.data, isReview = param.isReview, className = param.className;
    var excellent = (0,TranslationContext/* useTranslation */.m)().excellent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-x-10 px-[1.3rem] lg:px-0 " + className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:w-64 xl:w-360 bg-red-50 relative hidden lg:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative w-full h-60",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: data.resim,
                            layout: "fill",
                            loader: LoaderRemote/* default */.Z,
                            alt: data.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 left-0 z-10 bg-review-img-gra w-full h-24 pl-9 pt-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-white text-base font-bold",
                            children: data.baslik
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: isReview ? "flex lg:justify-between " : "flex lg:justify-between lg:mt-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: isReview ? "h-36 lg:h-28 w-full lg:hidden" : "h-28 w-32 mm:w-44 lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-full h-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: data.resim,
                                        layout: "fill",
                                        loader: LoaderRemote/* default */.Z,
                                        objectFit: "cover",
                                        alt: data.title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-col text-brand-black hidden lg:flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold text-base leading-6",
                                        children: data.isim
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs opacity-50 -mt-0.5",
                                        children: data.tarih
                                    })
                                ]
                            }),
                            isReview != true && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col lg:items-end justify-center pl-4 lg:pl-0 lg:hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-brand-black text-xl mm:text-2xl font-bold lg:hidden",
                                        children: data.baslik
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-brand-gray-9 lg:text-brand-black font-bold text-13 mr-1 mt-0.5 lg:mt-0",
                                        children: data.bolge
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-4 text-brand-black opacity-50 text-sm order-3 lg:order-none " + (!isReview ? "max-h-16 overflow-hidden lg:max-h-max" : ""),
                        children: data.mesaj
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-3.5 lg:mt-auto flex items-center order-2 lg:order-none justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-brand-black lg:hidden flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold text-base leading-6",
                                        children: data.isim
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs opacity-50 -mt-0.5",
                                        children: data.tarih
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-black lg:text-primary font-bold text-4xl",
                                        children: [
                                            data.puan,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                className: "text-15 -ml-1.5",
                                                children: "/5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-brand-black font-bold text-xxs -mt-2.5",
                                        children: [
                                            excellent,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "flex float- right text-primary fill-primary stroke-primary mt-0.5 ml-1",
                                                children: Array.from(Array(parseInt(data.puan)).keys()).map(function(e, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/icons/FaStarPrimary.svg",
                                                        width: 10,
                                                        height: 10,
                                                        alt: "Star Icon",
                                                        layout: "fixed"
                                                    }, i);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Index_ReviewItem = (ReviewItem);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/VillaItem.module.css
var VillaItem_module = __webpack_require__(49601);
var VillaItem_module_default = /*#__PURE__*/__webpack_require__.n(VillaItem_module);
// EXTERNAL MODULE: ./components/Detail/Photos.module.css
var Photos_module = __webpack_require__(98627);
var Photos_module_default = /*#__PURE__*/__webpack_require__.n(Photos_module);
;// CONCATENATED MODULE: ./components/Pages/OwnerVerification.js


var OwnerVerification = function(param) {
    var ssr = param.ssr;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
        className: "w-full h-screen",
        src: "https://esign.natsisa.com/".concat((ref = ssr.result) === null || ref === void 0 ? void 0 : ref.hash, "?Domain=").concat((ref1 = ssr.result) === null || ref1 === void 0 ? void 0 : ref1.domain)
    });
};
/* harmony default export */ var Pages_OwnerVerification = (OwnerVerification);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/Pages/Blank.js
















var Blank_SinglePaymentPage = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 70618));
}, {
    ssr: false
});
var Loading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Photos_module_default()).Photos,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full relative"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full relative"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full relative"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full relative"
            })
        ]
    });
};
var Content = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 91794).then(__webpack_require__.bind(__webpack_require__, 91794));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91794)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
    }
});
var Blank = function(param) {
    var ssr = param.ssr, action = param.action, isAppWebView = param.isAppWebView;
    var page = ssr.result;
    var comp = {
        StaticPage: Pages_StaticPage,
        GetOffer: Pages_GetOffer,
        Advertise: Pages_Advertise,
        SinglePayment: Blank_SinglePaymentPage,
        OwnerVerification: Pages_OwnerVerification
    };
    var Component = comp[action];
    if (action != "Detail" && action != "BankAccounts" && action != "Reviews") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        ssr: ssr,
        isAppWebView: isAppWebView
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
                data: ssr.result.BreadCrumb,
                isAppWebView: isAppWebView
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mb-8",
                children: [
                    (page === null || page === void 0 ? void 0 : page.cat) == "508" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                Images: page._photos,
                                styles: (Photos_module_default())
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "break-words",
                        id: "content",
                        dangerouslySetInnerHTML: {
                            __html: page.icerik
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-2 gap-2 lg:gap-5 lg:grid-cols-4",
                        children: page._pages && page._pages.map(function(item, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative flex items-end justify-start w-full h-32 overflow-hidden text-left rounded-lg shadow-inner lg:h-96",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: item.url,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        title: item.title,
                                        className: "pb-2 font-medium text-md group",
                                        children: [
                                            item.resim && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "fill",
                                                src: item.resim,
                                                objectFit: "cover",
                                                sizes: "(max-width: 768px) 60vw, 25vw",
                                                loader: LoaderRemote/* default */.Z,
                                                alt: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "z-10 px-2 lg:px-5 relative text-white font-bold text-sm mm:text-base lg:text-2xl transition-all duration-200 translate-y-0 lg:translate-y-4 group-hover:translate-y-0 " + (action != "Destination" ? "lg:mb-4 " : "") + (VillaItem_module_default()).Ribbon,
                                                children: item.baslik
                                            })
                                        ]
                                    })
                                })
                            }, key);
                        })
                    }),
                    (page === null || page === void 0 ? void 0 : page.cat) != "508" ? page._photos && /*#__PURE__*/ (0,jsx_runtime.jsx)(Blank_Photos, {
                        data: page._photos
                    }) : "",
                    page._faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(Blank_Faq, {
                        data: page._faq
                    }),
                    page._bankAccounts && page._bankAccounts.map(function(item, key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pages_BankaItem, {
                            item: item
                        }, key);
                    }),
                    page._reviews && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col gap-y-5",
                        children: page._reviews.map(function(item, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ReviewItem, {
                                isReview: 1,
                                data: item
                            }, key);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mb-40"
            })
        ]
    });
};
/* harmony default export */ var Pages_Blank = (Blank);


/***/ }),

/***/ 16719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var react_mask_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18935);








"use client";
var Input = function(_param) {
    var label = _param.label, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "label"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_2__/* .useField */ .U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    // useEffect(() => {
    //   if (field.value) helpers.setTouched(true);
    // }, [field.value]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            props.mask ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_mask_field__WEBPACK_IMPORTED_MODULE_3__/* .MaskField */ .V, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: "border-gray-300 block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary peer " + (!meta.error && field.value ? "border-green-500 focus:!border-green-500" : "") + (meta.error && field.value ? " border-red-500 focus:!border-red-500" : " ")
            }, field, props), {
                id: props.id || props.name
            })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: "border-gray-300 block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary peer " + (!meta.error && meta.touched ? "border-green-500 focus:border-green-500" : "") + (meta.error && meta.touched ? " border-red-500 focus:border-red-500" : " ")
            }, field, props), {
                id: props.id || props.name
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.name,
                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-brand-color-secondary duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-brand-color-secondary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 71121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16543);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73040);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82175);





var Installement = function(param) {
    var handleChange = param.handleChange, installement = param.installement, paymentDetails = param.paymentDetails;
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_4__/* .useFormikContext */ .u6)();
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .m)(), installementFull = ref.installementFull, installementText = ref.installement;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (installement.length <= 1) {
            formik.setFieldValue("installement", 1);
        }
    }, [
        installement
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
        name: "installement",
        onChange: handleChange,
        className: "mt-6 bg-gray-50 border outline-none focus:border-brand-color-secondary border-gray-300 text-gray-900 text-sm rounded-lg   w-full p-2.5 transform-gpu transition-all origin-top  " + (installement.length > 1 ? "scale-y-1 " : "scale-y-0 hidden"),
        children: installement.map(function(e, l) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: e.installmentNumber,
                children: e.installmentNumber == "1" || e.installmentNumber == "0" ? installementFull : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        e.installmentNumber,
                        " ",
                        installementText,
                        " x",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            Symbol: paymentDetails.Symbol,
                            value: e.installmentPrice,
                            decimalScale: 2
                        }),
                        " ",
                        "=",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            Symbol: paymentDetails.Symbol,
                            value: e.totalPrice,
                            decimalScale: 2
                        })
                    ]
                })
            }, "installement_" + l);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Installement);


/***/ }),

/***/ 1777:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _icons_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17601);



var PaymentItem = function(param) {
    var idFocus = param.idFocus, nameplaceholder = param.nameplaceholder, icon = param.icon, name = param.name;
    return /*#__PURE__*/ _jsxs("div", {
        className: "border py-3 px-4 flex justify-center items-center gap-x-2 sm:gap-x-7",
        children: [
            /*#__PURE__*/ _jsx("label", {
                htmlFor: idFocus,
                className: "font-semibold sm:w-[30%] w-[40%] text-[12px] sm:text-[16px]",
                children: nameplaceholder
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center w-full",
                children: [
                    icon && /*#__PURE__*/ _jsx("span", {
                        className: "bg-[#f8f9fa] py-2 px-[0.75rem] rounded-l border",
                        children: /*#__PURE__*/ _jsx(Icon, {
                            name: icon
                        })
                    }),
                    /*#__PURE__*/ _jsx("input", {
                        type: "text",
                        name: name,
                        className: "border rounded-r w-full px-3 py-2 placeholder:text-black",
                        id: idFocus
                    })
                ]
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (PaymentItem)));


/***/ }),

/***/ 22724:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _icons_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17601);



var PaymentTextarea = function(param) {
    var nameplaceholder = param.nameplaceholder, idFocus = param.idFocus, name = param.name, icon = param.icon;
    return /*#__PURE__*/ _jsxs("div", {
        className: "border py-3 px-4 flex justify-center items-center gap-x-7",
        children: [
            /*#__PURE__*/ _jsx("label", {
                htmlFor: idFocus,
                className: "font-semibold text-[12px] sm:text-[16px] w-[34%] sm:w-[30%]",
                children: nameplaceholder
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center w-full",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "bg-[#f8f9fa] py-2 px-[0.75rem] rounded-l border",
                        children: /*#__PURE__*/ _jsx(Icon, {
                            name: icon
                        })
                    }),
                    /*#__PURE__*/ _jsx("textarea", {
                        type: "text",
                        name: name,
                        className: "border rounded-r w-full leading-5 px-3 resize-none placeholder:text-black",
                        id: idFocus
                    })
                ]
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (PaymentTextarea)));


/***/ }),

/***/ 70618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pages_SinglePaymentPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Pages/PaymentCustomer/PaymentItem.js
var PaymentItem = __webpack_require__(1777);
// EXTERNAL MODULE: ./components/Pages/PaymentCustomer/PaymentTextarea.js
var PaymentTextarea = __webpack_require__(22724);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./themes/themes.js
var themes = __webpack_require__(89507);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/yup-locales/dist/yup-locales.esm.js
var yup_locales_esm = __webpack_require__(18700);
// EXTERNAL MODULE: ./languages/tr.js
var tr = __webpack_require__(49323);
;// CONCATENATED MODULE: ./validations/PosSheme.js



if (true) es/* setLocale */.i_(yup_locales_esm.tr); // en: Yup varsayilan (Ingilizce) mesajlari
var PosSheme = es/* object */.Ry().shape({
    name: es/* string */.Z_().required(),
    email: es/* string */.Z_().required().email(),
    phone: es/* string */.Z_().required(),
    price: es/* number */.Rx().required(),
    cardNumber: es/* string */.Z_().length(19, tr/* language.cardNumberLength */.d.cardNumberLength).required(),
    month: es/* string */.Z_().matches(/0[1-9]|1[0-2]/).required(),
    year: es/* string */.Z_().matches(/^\d{2}$/).required(),
    cvv: es/* string */.Z_().matches(/^\d{3}$/).required()
});

// EXTERNAL MODULE: ./components/Pages/Payment/Input.js
var Input = __webpack_require__(16719);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
// EXTERNAL MODULE: ./components/DefaultCurrencyFormat.js
var DefaultCurrencyFormat = __webpack_require__(16543);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Loaders/ReservationsLoading.js
var ReservationsLoading = __webpack_require__(36289);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ri/RiShieldCheckFill.js
var RiShieldCheckFill = __webpack_require__(31532);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(50196);
;// CONCATENATED MODULE: ./components/DetectCardNumber.js



var DetectCardNumber = function(param) {
    var setInstallement = param.setInstallement;
    var ref = (0,formik_esm/* useFormikContext */.u6)(), values = ref.values, setFieldValue = ref.setFieldValue;
    var ref1 = (0,react.useState)(""), cardNumberListen = ref1[0], setCardNumberListen = ref1[1];
    (0,react.useEffect)(function() {
        if (values.cardNumber.length >= 7) setCardNumberListen(values.cardNumber.slice(0, 7).replace("-", ""));
        else setCardNumberListen("");
    }, [
        values
    ]);
    (0,react.useEffect)(function() {
        if (cardNumberListen.length == 6 && (values === null || values === void 0 ? void 0 : values.price)) {
            axios/* default.post */.ZP.post("/api/InstallmentInfo", {
                binNumber: cardNumberListen,
                price: values === null || values === void 0 ? void 0 : values.price
            }).then(function(e) {
                if (e.data.status == "success") {
                    setInstallement(e.data.installmentDetails[0].installmentPrices);
                    setFieldValue("installement", 0);
                } else {
                    setInstallement([]);
                    setFieldValue("installement", 0);
                }
            });
        } else setInstallement([]);
    }, [
        cardNumberListen,
        values === null || values === void 0 ? void 0 : values.price
    ]);
    return null;
};

// EXTERNAL MODULE: ./components/Pages/Payment/Installement.js
var Installement = __webpack_require__(71121);
;// CONCATENATED MODULE: ./helper/makeid.js
function makeid(length) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    var counter = 0;
    while(counter < length){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

// EXTERNAL MODULE: ./node_modules/@fancyapps/ui/dist/fancybox.esm.js
var fancybox_esm = __webpack_require__(22689);
// EXTERNAL MODULE: ./node_modules/@fancyapps/ui/dist/fancybox.css
var fancybox = __webpack_require__(48112);
;// CONCATENATED MODULE: ./components/Pages/SinglePaymentPage.js



























var SinglePaymentPage = function(param) {
    var ssr = param.ssr;
    var sortObjectKeys = function sortObjectKeys(obj) {
        // Objeden tüm anahtarları al
        var keys = Object.keys(obj);
        // Anahtarları alfabetik olarak sırala (büyük/küçük harf duyarlı)
        keys.sort(function(a, b) {
            return a.localeCompare(b, undefined, {
                sensitivity: "base"
            });
        });
        // Yeni bir obje oluştur
        var sortedObj = {};
        // Sıralanmış anahtarlara göre yeni objeyi doldur
        keys.forEach(function(key) {
            sortedObj[key] = obj[key];
        });
        return sortedObj;
    };
    var formRef = (0,react.useRef)(null);
    var ref = (0,TranslationContext/* useTranslation */.m)(), select = ref.select, dateMonth = ref.dateMonth, dateYear = ref.dateYear;
    var ref1 = (0,react.useState)([]), installement = ref1[0], setInstallement = ref1[1];
    var ref2 = (0,react.useState)({}), formData = ref2[0], setFormData = ref2[1];
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(false), isSuccess = ref3[0], setIsSuccess = ref3[1];
    var ref4 = (0,react.useState)(null), response = ref4[0], setResponse = ref4[1];
    var ref5 = (0,TranslationContext/* useTranslation */.m)(), dear = ref5.dear, paymentStatusChecking = ref5.paymentStatusChecking, paymentSuccessToast = ref5.paymentSuccessToast, successTitle = ref5.successTitle, paymentReceived = ref5.paymentReceived, paymentInfoSentTo = ref5.paymentInfoSentTo, contactAndPaymentInfo = ref5.contactAndPaymentInfo, fullNameLabel = ref5.fullNameLabel, creditCardInfo = ref5.creditCardInfo, cardNumberLabel = ref5.cardNumberLabel, loadingShort = ref5.loadingShort, payBtn = ref5.payBtn, sslNotice = ref5.sslNotice;
    var HandleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, actions) {
            var conversationId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        values.VirtualPosId = ssr.result.VirtualPosId;
                        if (values.VirtualPosId == 3 && values.installement <= 1) {
                            values.VirtualPosId = 4;
                        }
                        if (!(values.VirtualPosId == 3)) {
                            _ctx.next = 8;
                            break;
                        }
                        conversationId = makeid(20);
                        _ctx.next = 6;
                        return axios/* default.post */.ZP.post("/api/PaymentWithoutReservation", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                            _: conversationId
                        })).then(function(result) {
                            if (result.data.success) {
                                fancybox_esm/* Fancybox.show */.KR.show([
                                    {
                                        id: "xx111",
                                        src: "/api/PaymentForm?_=" + conversationId,
                                        type: "iframe",
                                        preload: false,
                                        width: 500,
                                        height: 700
                                    }, 
                                ], {
                                    on: {
                                        closing: function closing() {
                                            var toastId = react_toastify_esm/* toast.loading */.Am.loading(paymentStatusChecking);
                                            (0,api/* CheckPaymentStatus */._l)(conversationId).then(function(e) {
                                                if (e.data.status == "success") {
                                                    setResponse(e.data);
                                                    setIsSuccess(true);
                                                    react_toastify_esm/* toast.success */.Am.success(paymentSuccessToast);
                                                }
                                            }).finally(function() {
                                                react_toastify_esm/* toast.dismiss */.Am.dismiss(toastId);
                                            });
                                        }
                                    }
                                });
                            //setPaymentHtml(JSON.stringify(result.data));
                            //setPaymentHtml(atob(result.data.threeDSHtmlContent));
                            //Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
                            } else {
                                react_toastify_esm/* toast.error */.Am.error(result.data.error);
                            }
                        }).catch(function(e) {
                            react_toastify_esm/* toast.error */.Am.error(e.message);
                        }).finally(function() {
                            actions.setSubmitting(false);
                        });
                    case 6:
                        _ctx.next = 10;
                        break;
                    case 8:
                        _ctx.next = 10;
                        return (0,api/* CreateHashData */.Rw)(values).then(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
                                var data, random, newFormData;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            data = e.data.data;
                                            random = Math.floor(Math.random() * 1000000000);
                                            newFormData = (0,_object_spread/* default */.Z)({
                                                pan: values.cardNumber.replaceAll("-", ""),
                                                Ecom_Payment_Card_ExpDate_Month: values.month,
                                                Ecom_Payment_Card_ExpDate_Year: values.year,
                                                cv2: values.cvv,
                                                odeme_tipi: "Kredi Kart\u0131",
                                                clientid: data.ClientId,
                                                amount: data.Amount,
                                                sipBil: random,
                                                rnd: random,
                                                okUrl: data.OkUrl,
                                                failUrl: data.FailUrl,
                                                TranType: data.Auth,
                                                callbackUrl: data.callback,
                                                Instalment: data.Installment,
                                                storetype: "3D_PAY",
                                                hashAlgorithm: "ver3",
                                                lang: "tr",
                                                currency: values.currency,
                                                BillToName: values.name,
                                                BillToCompany: values.name,
                                                Expiry: values.month + values.year,
                                                VirtualPosId: values.VirtualPosId,
                                                harici: "1",
                                                isim: values.name,
                                                telefon: values.phone,
                                                mesaj: values.message,
                                                gonder: "\xd6demeyi Yap"
                                            }, values);
                                            delete newFormData.cardNumber;
                                            _ctx.next = 6;
                                            return axios/* default.post */.ZP.post("https://api.balayivillasikirala.com.tr" + "/CreateForm", newFormData).then(function(e) {
                                                if (e.status == 200) {
                                                    setFormData(sortObjectKeys((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newFormData), {
                                                        ip: e.data.ip,
                                                        HASH: e.data.hash
                                                    })));
                                                    setTimeout(function() {
                                                        formRef.current.submit();
                                                    }, 200);
                                                }
                                            });
                                        case 6:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(e) {
                                return _ref.apply(this, arguments);
                            };
                        }()).finally(function() {
                            actions.setSubmitting(false);
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function HandleSubmit(values, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.h) {
            var toastId = react_toastify_esm/* toast.loading */.Am.loading(paymentStatusChecking);
            (0,api/* GetPaymentStatus */.C2)(router.query.h).then(function(e) {
                var r = JSON.parse(e.data.data.Response);
                if ((r === null || r === void 0 ? void 0 : r.ProcReturnCode) == "00") {
                    setResponse(r);
                    setIsSuccess(true);
                    react_toastify_esm/* toast.success */.Am.success(paymentSuccessToast);
                }
                if (r.mdErrorMsg && (r === null || r === void 0 ? void 0 : r.ProcReturnCode) !== "00") {
                    react_toastify_esm/* toast.error */.Am.error(r.mdErrorMsg);
                }
            }).finally(function() {
                react_toastify_esm/* toast.dismiss */.Am.dismiss(toastId);
            });
        }
    }, [
        router.query.h
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center mx-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "my-5 drop-shadow-lg bg-white w-[800px] ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex py-5 justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: themes/* default.logo */.Z.logo,
                            width: 240,
                            height: 90,
                            alt: "Logo"
                        })
                    })
                }),
                isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full justify-center items-center text-center flex-col mb-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RiShieldCheckFill/* RiShieldCheckFill */.e, {
                                    size: 96,
                                    className: "text-green-500"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold text-lg text-green-500 mt-2",
                                    children: successTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-sm text-brand-gray-2",
                            children: paymentReceived
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: "h-0.25 bg-gray-100 w-full my-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm text-brand-gray text-center leading-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "text-black font-extrabold",
                                    children: response.email
                                }),
                                " ",
                                paymentInfoSentTo,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                            initialValues: {
                                name: "",
                                email: "",
                                phone: "",
                                price: "",
                                message: "",
                                currency: "949",
                                cardNumber: "",
                                month: "",
                                year: "",
                                cvv: "",
                                installement: 1
                            },
                            validationSchema: PosSheme,
                            onSubmit: HandleSubmit,
                            children: function(props) {
                                var ref, ref1;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                                    onSubmit: props.handleSubmit,
                                    className: "flex flex-wrap p-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center py-3 text-15 font-extrabold bg-[#f8f9fa] mb-2 w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: contactAndPaymentInfo
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 group p-1 my-2 w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "name",
                                                placeholder: " ",
                                                label: fullNameLabel
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 group p-1 my-2 w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "email",
                                                placeholder: " ",
                                                label: "Email"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 group p-1 my-2 w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "phone",
                                                placeholder: " ",
                                                label: "Telefon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 group p-1 my-2 w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "message",
                                                placeholder: " ",
                                                label: "Mesaj"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 w-3/4 group p-1 my-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "price",
                                                placeholder: " ",
                                                label: "Tutar"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 w-1/4 group p-1 my-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                as: "select",
                                                name: "currency",
                                                className: "border-gray-300 block rounded-md py-5 px-6 w-full   text-[0.875rem] bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary " + (!props.errors.currency && props.touched.currency ? "border-green-500 focus:!border-green-500" : "") + (props.errors.currency && props.touched.currency ? " border-red-500 focus:!border-red-500" : " "),
                                                children: ssr.result.Currencies.map(function(e, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: e.PosCode,
                                                        children: e.CurrencyCode
                                                    }, i);
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center py-3 text-15 font-extrabold bg-[#f8f9fa] w-full mt-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: creditCardInfo
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 w-full group p-1 my-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "cardNumber",
                                                placeholder: " ",
                                                label: cardNumberLabel,
                                                mask: "____-____-____-____",
                                                replacement: {
                                                    _: /\d/
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 w-full group p-1 my-2 -mt-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Installement/* default */.Z, {
                                                installement: installement,
                                                handleChange: props.handleChange,
                                                paymentDetails: {
                                                    Symbol: "\u20BA"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid grid-cols-3 gap-x-4 p-1 w-full",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative z-0 mb-6 w-full group",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        name: "month",
                                                        placeholder: "- -",
                                                        label: dateMonth,
                                                        mask: "__",
                                                        replacement: {
                                                            _: /\d/
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative z-0 mb-6 w-full group",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        name: "year",
                                                        placeholder: "- -",
                                                        label: dateYear,
                                                        mask: "__",
                                                        replacement: {
                                                            _: /\d/
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative z-0 mb-6 w-full group",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        name: "cvv",
                                                        placeholder: "- - -",
                                                        label: "CVC",
                                                        mask: "___",
                                                        replacement: {
                                                            _: /\d/
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-red-500 font-bold text-xl mx-auto",
                                            children: ((ref = installement.find(function(x) {
                                                return x.installmentNumber == props.values.installement;
                                            })) === null || ref === void 0 ? void 0 : ref.totalPrice) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                                value: (ref1 = installement.find(function(x) {
                                                    return x.installmentNumber == props.values.installement;
                                                })) === null || ref1 === void 0 ? void 0 : ref1.totalPrice,
                                                Symbol: ssr.result.Currencies.find(function(e) {
                                                    return e.PosCode === props.values.currency;
                                                }).Symbol
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                                value: props.values.price,
                                                Symbol: ssr.result.Currencies.find(function(e) {
                                                    return e.PosCode === props.values.currency;
                                                }).Symbol
                                            })
                                        }),
                                        ssr.result.VirtualPosId == 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetectCardNumber, {
                                            setInstallement: setInstallement
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "submit",
                                            disabled: props.isSubmitting || !props.isValid,
                                            className: "mt-3 w-full text-white md:px-[2.75rem] px-8 md:py-[1.188rem] py-3 duration-200 bg-product-type-color hover:opacity-90 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm text-center disabled:opacity-60 disabled:cursor-not-allowed",
                                            children: props.isSubmitting ? loadingShort : payBtn
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center w-full mt-20",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/visamaster.jpg",
                                                className: "w-[490px] h-[148px]",
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "p-4 rounded bg-[#fff3cd] text-[12px] sm:text-[16px] mx-2 mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: sslNotice.replace("{domain}", "https://www.balayivillasikirala.com.tr").replace("{site}", "Balayi Villası Kirala")
                                            })
                                        })
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                            ref: formRef,
                            action: ssr.result.VirtualPosSettings.Action || "https://sanalpos.halkbank.com.tr/fim/est3Dgate",
                            method: "post",
                            children: Object.keys(formData).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "hidden",
                                    readOnly: true,
                                    name: key,
                                    value: formData[key]
                                }, key);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Pages_SinglePaymentPage = (SinglePaymentPage);


/***/ }),

/***/ 23515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86408);
/* harmony import */ var react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82175);
/* harmony import */ var _styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35928);
/* harmony import */ var _styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_phone_input_2_lang_tr_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95509);









var PhoneInputW = function(_param) {
    var label = _param.label, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "label"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_4__/* .useField */ .U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    var setError = helpers.setError, setValue = helpers.setValue, setTouched = helpers.setTouched;
    var ref1 = (0,formik__WEBPACK_IMPORTED_MODULE_4__/* .useFormikContext */ .u6)(), values = ref1.values, submitForm = ref1.submitForm, submitCount = ref1.submitCount, setFieldValue = ref1.setFieldValue;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "Turkey",
        dialCode: "90",
        countryCode: "tr",
        format: "+.. ... ... .. .."
    }), country = ref2[0], setCountry = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isError = ref3[0], setIsError = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (country) {
            var pattern = new RegExp("^\\d{".concat(country.format.replaceAll(" ", "").replace("+", "").length, "}$"));
            if (!meta.touched) setTouched(true);
            if (props.isrequired == "required") {
                if (country.countryCode == "tr") {
                    setIsError(pattern.test(field.value) == false);
                    setFieldValue(props.validname, !(pattern.test(field.value) == false));
                } else {
                    setIsError(false);
                    setFieldValue(props.validname, true);
                }
            //setFieldValue(props.validname, true);
            } else {
                if (field.value.length <= country.dialCode.length) {
                    setTouched(false);
                    setFieldValue(props.validname, true);
                    setError(false);
                } else {
                    //setIsError(pattern.test(val) == false);
                    if (!meta.touched) setTouched(true);
                    //setFieldValue(
                    //  props.validname,
                    //  pattern.test(val) == true ? true : null
                    //);
                    setFieldValue(props.validname, true);
                }
            }
        }
    }, [
        field.value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative text-brand-gray-9 bg-white rounded-md shadow-[0_22px_24px_0_rgba(226,236,240,0.13)] flex items-center ".concat(props.mode == "simple" ? "h-full border px-6" : "h-[70px]  px-9", "  ").concat(!meta.error && meta.touched && !isError ? "".concat(props.mode == "simple" ? "border" : "border-2", "  border-green-400") : null, " ").concat(meta.error && meta.touched || isError && field.value.length > country.dialCode.length || submitCount > 0 && !field.value ? "".concat(props.mode == "simple" ? "border" : "border-2", " border-red-400") : null),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "font-semibold text-sm",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "h-full w-0.25 ml-5 mr-6 flex-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_2___default()), {
                        className: (_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default().PhoneInput),
                        localization: react_phone_input_2_lang_tr_json__WEBPACK_IMPORTED_MODULE_5__,
                        country: "tr",
                        inputClass: (_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default().input),
                        buttonClass: (_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default().dropDown),
                        preferredCountries: [
                            "tr"
                        ],
                        enableLongNumbers: true,
                        onChange: function(value, country, e, formattedValue) {
                            setValue(value);
                            setCountry(country);
                        },
                        value: field.value
                    }),
                    props.isrequired && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: " absolute right-4 top-4",
                        children: "*"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhoneInputW);


/***/ }),

/***/ 92072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _languages_tr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49323);


function useLocale() {
    var locale = _languages_tr__WEBPACK_IMPORTED_MODULE_1__/* .language.datePickerlang */ .d.datePickerlang;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), localeData = ref[0], setLocaleData = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        __webpack_require__(71213)("./".concat(locale, "/index.js")).then(function(module) {
            return setLocaleData(module.default);
        }).catch(function(error) {
            return console.error("Failed to load locale: ".concat(locale), error);
        });
    }, [
        locale
    ]);
    return localeData;
}
/* harmony default export */ __webpack_exports__["Z"] = (useLocale);


/***/ }),

/***/ 17601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


var InfoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 49562).then(__webpack_require__.bind(__webpack_require__, 49562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49562)
            ];
        }
    }
});
var InstagramIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 81147).then(__webpack_require__.bind(__webpack_require__, 81147));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81147)
            ];
        }
    }
});
var LogoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 60563).then(__webpack_require__.bind(__webpack_require__, 60563));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60563)
            ];
        }
    }
});
var FacebookIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55849).then(__webpack_require__.bind(__webpack_require__, 55849));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55849)
            ];
        }
    }
});
var YoutubeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 86759).then(__webpack_require__.bind(__webpack_require__, 86759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86759)
            ];
        }
    }
});
var DatepickerArrowsIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 10945).then(__webpack_require__.bind(__webpack_require__, 10945));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10945)
            ];
        }
    }
});
var LocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34364).then(__webpack_require__.bind(__webpack_require__, 34364));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34364)
            ];
        }
    }
});
var SearchIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 39750).then(__webpack_require__.bind(__webpack_require__, 39750));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39750)
            ];
        }
    }
});
var ArrowDownIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5915).then(__webpack_require__.bind(__webpack_require__, 5915));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5915)
            ];
        }
    }
});
var TimesIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 36539).then(__webpack_require__.bind(__webpack_require__, 36539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36539)
            ];
        }
    }
});
var PaymentOptionIcon1 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 57905).then(__webpack_require__.bind(__webpack_require__, 57905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57905)
            ];
        }
    }
});
var PaymentOptionIcon2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18686).then(__webpack_require__.bind(__webpack_require__, 18686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18686)
            ];
        }
    }
});
var HeartIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14119).then(__webpack_require__.bind(__webpack_require__, 14119));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14119)
            ];
        }
    }
});
var AttentionIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55613).then(__webpack_require__.bind(__webpack_require__, 55613));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55613)
            ];
        }
    }
});
var FaturaIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52415).then(__webpack_require__.bind(__webpack_require__, 52415));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52415)
            ];
        }
    }
});
var CallIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 26006).then(__webpack_require__.bind(__webpack_require__, 26006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26006)
            ];
        }
    }
});
var WhatsappnewIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 40305).then(__webpack_require__.bind(__webpack_require__, 40305));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40305)
            ];
        }
    }
});
var ReverseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 72142).then(__webpack_require__.bind(__webpack_require__, 72142));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72142)
            ];
        }
    }
});
var MapIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 88450).then(__webpack_require__.bind(__webpack_require__, 88450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88450)
            ];
        }
    }
});
var Icons_new = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 793).then(__webpack_require__.bind(__webpack_require__, 793));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(793)
            ];
        }
    }
});
var Icons_new2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14973).then(__webpack_require__.bind(__webpack_require__, 14973));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14973)
            ];
        }
    }
});
var Icons_new3 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 38796).then(__webpack_require__.bind(__webpack_require__, 38796));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38796)
            ];
        }
    }
});
var Icons_new4 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68344).then(__webpack_require__.bind(__webpack_require__, 68344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68344)
            ];
        }
    }
});
var WorkingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 73477).then(__webpack_require__.bind(__webpack_require__, 73477));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73477)
            ];
        }
    }
});
var ProblemreportIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 44059).then(__webpack_require__.bind(__webpack_require__, 44059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44059)
            ];
        }
    }
});
var WheltimeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 63270).then(__webpack_require__.bind(__webpack_require__, 63270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63270)
            ];
        }
    }
});
var GancelIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 51623).then(__webpack_require__.bind(__webpack_require__, 51623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51623)
            ];
        }
    }
});
var GuestconfirmationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 21443).then(__webpack_require__.bind(__webpack_require__, 21443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21443)
            ];
        }
    }
});
var CloseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25194).then(__webpack_require__.bind(__webpack_require__, 25194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25194)
            ];
        }
    }
});
var VillaLocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34920).then(__webpack_require__.bind(__webpack_require__, 34920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34920)
            ];
        }
    }
});
var PlayButtonIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17686).then(__webpack_require__.bind(__webpack_require__, 17686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17686)
            ];
        }
    }
});
var DetailIncludedPriceIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 59715).then(__webpack_require__.bind(__webpack_require__, 59715));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59715)
            ];
        }
    }
});
var BarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19272).then(__webpack_require__.bind(__webpack_require__, 19272));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19272)
            ];
        }
    }
});
var CallCenterIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18238).then(__webpack_require__.bind(__webpack_require__, 18238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18238)
            ];
        }
    }
});
var UserIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 78822).then(__webpack_require__.bind(__webpack_require__, 78822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78822)
            ];
        }
    }
});
var ClockIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 76255).then(__webpack_require__.bind(__webpack_require__, 76255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76255)
            ];
        }
    }
});
var PaginationPrevIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17151).then(__webpack_require__.bind(__webpack_require__, 17151));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17151)
            ];
        }
    }
});
var PaginationNextIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18229).then(__webpack_require__.bind(__webpack_require__, 18229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18229)
            ];
        }
    }
});
var ShareIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 91788).then(__webpack_require__.bind(__webpack_require__, 91788));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91788)
            ];
        }
    }
});
var HousekeepingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 29097).then(__webpack_require__.bind(__webpack_require__, 29097));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29097)
            ];
        }
    }
});
var CameraIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 22437).then(__webpack_require__.bind(__webpack_require__, 22437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22437)
            ];
        }
    }
});
var TeamIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 42908).then(__webpack_require__.bind(__webpack_require__, 42908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42908)
            ];
        }
    }
});
var CommentIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 97088).then(__webpack_require__.bind(__webpack_require__, 97088));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97088)
            ];
        }
    }
});
var WalletIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18688).then(__webpack_require__.bind(__webpack_require__, 18688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18688)
            ];
        }
    }
});
var UserodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18024).then(__webpack_require__.bind(__webpack_require__, 18024));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18024)
            ];
        }
    }
});
var MailodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 37822).then(__webpack_require__.bind(__webpack_require__, 37822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37822)
            ];
        }
    }
});
var PhoneodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 28892).then(__webpack_require__.bind(__webpack_require__, 28892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28892)
            ];
        }
    }
});
var EditodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 35623).then(__webpack_require__.bind(__webpack_require__, 35623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35623)
            ];
        }
    }
});
var LockodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9748).then(__webpack_require__.bind(__webpack_require__, 9748));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9748)
            ];
        }
    }
});
var LocationPinIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 80707).then(__webpack_require__.bind(__webpack_require__, 80707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80707)
            ];
        }
    }
});
var StarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 99484).then(__webpack_require__.bind(__webpack_require__, 99484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99484)
            ];
        }
    }
});
var KtbIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9842).then(__webpack_require__.bind(__webpack_require__, 9842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9842)
            ];
        }
    }
});
var Icon = function(param) {
    var name = param.name, _size = param.size, size = _size === void 0 ? 24 : _size, className = param.className;
    var icons = {
        info: InfoIcon,
        logo: LogoIcon,
        instagram: InstagramIcon,
        facebook: FacebookIcon,
        youtube: YoutubeIcon,
        datepickerArrows: DatepickerArrowsIcon,
        location: LocationIcon,
        search: SearchIcon,
        ArrowDown: ArrowDownIcon,
        Times: TimesIcon,
        PaymentOption1: PaymentOptionIcon1,
        PaymentOption2: PaymentOptionIcon2,
        Heart: HeartIcon,
        attention: AttentionIcon,
        fatura: FaturaIcon,
        call: CallIcon,
        whatsappnew: WhatsappnewIcon,
        reverse: ReverseIcon,
        map: MapIcon,
        newIcon1: Icons_new,
        newIcon2: Icons_new2,
        newIcon3: Icons_new3,
        newIcon4: Icons_new4,
        working: WorkingIcon,
        villaLocation: VillaLocationIcon,
        PlayButton: PlayButtonIcon,
        DetailIncludedPrice: DetailIncludedPriceIcon,
        Bar: BarIcon,
        CallCenter: CallCenterIcon,
        problemreport: ProblemreportIcon,
        wheltime: WheltimeIcon,
        gancel: GancelIcon,
        guestconfirmation: GuestconfirmationIcon,
        close: CloseIcon,
        user: UserIcon,
        clock: ClockIcon,
        PaginationPrev: PaginationPrevIcon,
        PaginationNext: PaginationNextIcon,
        Share: ShareIcon,
        Wallet: WalletIcon,
        Comment: CommentIcon,
        Camera: CameraIcon,
        Housekeeping: HousekeepingIcon,
        Team: TeamIcon,
        userodeme: UserodemeIcon,
        mailodeme: MailodemeIcon,
        phoneodeme: PhoneodemeIcon,
        editodeme: EditodemeIcon,
        lockodeme: LockodemeIcon,
        LocationPin: LocationPinIcon,
        Star: StarIcon,
        ktb: KtbIcon
    };
    var Component = icons[name];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        size: size,
        className: className
    });
};



/***/ }),

/***/ 98627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Photos":"Photos_Photos__BXhg3"};

/***/ }),

/***/ 49601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Ribbon":"VillaItem_Ribbon__3AjfG","SonDakikaBadge":"VillaItem_SonDakikaBadge__HiiUD","sonDakikaShine":"VillaItem_sonDakikaShine__IPWP5","SonDakikaBar":"VillaItem_SonDakikaBar__h9oBI"};

/***/ }),

/***/ 35928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PhoneInput":"PhoneInput_PhoneInput__q7Kkj","PhoneInputCountry":"PhoneInput_PhoneInputCountry__i4tLe","dropDown":"PhoneInput_dropDown__K8cbG","input":"PhoneInput_input__zsoED"};

/***/ })

}]);